// @preserve jQuery.floatThead 1.3.1 - http://mkoryak.github.io/floatThead/ - Copyright (c) 2012 - 2015 Misha Koryak
// @license MIT

!function (a) {
    function b(a, b) {
        if (8 == j) {
            var c = o.width(), d = h.debounce(function () {
                var a = o.width();
                c != a && (c = a, b())
            }, 1);
            o.on(a, d)
        } else o.on(a, h.debounce(b, 1))
    }

    function c(a) {
        window && window.console && window.console.error && window.console.error("jQuery.floatThead: " + a)
    }

    function d(a) {
        var b = a.getBoundingClientRect();
        return b.width || b.right - b.left
    }

    function e() {
        var b = a('<div style="width:50px;height:50px;overflow-y:scroll;position:absolute;top:-200px;left:-200px;"><div style="height:100px;width:100%"></div>');
        a("body").append(b);
        var c = b.innerWidth(), d = a("div", b).innerWidth();
        return b.remove(), c - d
    }

    function f(a) {
        if (a.dataTableSettings)for (var b = 0; b < a.dataTableSettings.length; b++) {
            var c = a.dataTableSettings[b].nTable;
            if (a[0] == c)return !0
        }
        return !1
    }

    function g(a, b, c) {
        var d = c ? "outerWidth" : "width";
        if (m && a.css("max-width")) {
            var e = 0;
            c && (e += parseInt(a.css("borderLeft"), 10), e += parseInt(a.css("borderRight"), 10));
            for (var f = 0; f < b.length; f++)e += b.get(f).offsetWidth;
            return e
        }
        return a[d]()
    }

    a.floatThead = a.floatThead || {}, a.floatThead.defaults = {
        headerCellSelector: "tr:visible:first>*:visible",
        zIndex: 1001,
        position: "auto",
        top: 0,
        bottom: 0,
        scrollContainer: function () {
            return a([])
        },
        getSizingRow: function (a) {
            return a.find("tbody tr:visible:first>*:visible")
        },
        floatTableClass: "floatThead-table",
        floatWrapperClass: "floatThead-wrapper",
        floatContainerClass: "floatThead-container",
        copyTableClass: !0,
        enableAria: !1,
        autoReflow: !1,
        debug: !1
    };
    var h = window._, i = "undefined" != typeof MutationObserver, j = function () {
        for (var a = 3, b = document.createElement("b"), c = b.all || []; a = 1 + a, b.innerHTML = "<!--[if gt IE " + a + "]><i><![endif]-->", c[0];);
        return a > 4 ? a : document.documentMode
    }(), k = /Gecko\//.test(navigator.userAgent), l = /WebKit\//.test(navigator.userAgent), m = function () {
        if (l) {
            var b = a('<div style="width:0px"><table style="max-width:100%"><tr><th><div style="min-width:100px;">X</div></th></tr></table></div>');
            a("body").append(b);
            var c = 0 == b.find("table").width();
            return b.remove(), c
        }
        return !1
    }, n = !k && !j, o = a(window);
    a.fn.floatThead = function (k) {
        if (k = k || {}, !h && (h = window._ || a.floatThead._, !h))throw new Error("jquery.floatThead-slim.js requires underscore. You should use the non-lite version since you do not have underscore.");
        if (8 > j)return this;
        var p = null;
        if (h.isFunction(m) && (m = m()), h.isString(k)) {
            var q = k, r = this;
            return this.filter("table").each(function () {
                var b = a(this), c = b.data("floatThead-lazy");
                c && b.floatThead(c);
                var d = b.data("floatThead-attached");
                if (d && h.isFunction(d[q])) {
                    var e = d[q]();
                    "undefined" != typeof e && (r = e)
                }
            }), r
        }
        var s = a.extend({}, a.floatThead.defaults || {}, k);
        if (a.each(k, function (b) {
                b in a.floatThead.defaults || !s.debug || c("Used [" + b + "] key to init plugin, but that param is not an option for the plugin. Valid options are: " + h.keys(a.floatThead.defaults).join(", "))
            }), s.debug) {
            var t = a.fn.jquery.split(".");
            1 == parseInt(t[0], 10) && parseInt(t[1], 10) <= 7 && c("jQuery version " + a.fn.jquery + " detected! This plugin supports 1.8 or better, or 1.7.x with jQuery UI 1.8.24 -> http://jqueryui.com/resources/download/jquery-ui-1.8.24.zip")
        }
        return this.filter(":not(." + s.floatTableClass + ")").each(function () {
            function k(a) {
                return a + ".fth-" + E + ".floatTHead"
            }

            function m() {
                var b = 0;
                if (G.children("tr:visible").each(function () {
                        b += a(this).outerHeight(!0)
                    }), "collapse" == F.css("border-collapse")) {
                    var c = parseInt(F.css("border-top-width"), 10), d = parseInt(F.find("thead tr:first").find(">*:first").css("border-top-width"), 10);
                    c > d && (b -= c / 2)
                }
                fb.outerHeight(b), gb.outerHeight(b)
            }

            function q() {
                var a = g(F, jb, !0), b = O.width() || a, c = "hidden" != O.css("overflow-y") ? b - L.vertical : b;
                if (cb.width(c), P) {
                    var d = 100 * a / c;
                    Y.css("width", d + "%")
                } else Y.outerWidth(a)
            }

            function r() {
                I = (h.isFunction(s.top) ? s.top(F) : s.top) || 0, J = (h.isFunction(s.bottom) ? s.bottom(F) : s.bottom) || 0
            }

            function t() {
                var b, c = G.find(s.headerCellSelector);
                if (ab ? b = $.find("col").length : (b = 0, c.each(function () {
                        b += parseInt(a(this).attr("colspan") || 1, 10)
                    })), b != N) {
                    N = b;
                    for (var d, e = [], f = [], g = [], h = 0; b > h; h++)e.push(s.enableAria && (d = c.eq(h).text()) ? '<th scope="col" class="floatThead-col">' + d + "</th>" : '<th class="floatThead-col"/>'), f.push("<col/>"), g.push("<fthtd style='display:table-cell;height:0;width:auto;'/>");
                    f = f.join(""), e = e.join(""), n && (g = g.join(""), bb.html(g), jb = bb.find("fthtd")), fb.html(e), gb = fb.find("th"), ab || $.html(f), hb = $.find("col"), Z.html(f), ib = Z.find("col")
                }
                return b
            }

            function u() {
                if (!K) {
                    if (K = !0, Q) {
                        var a = g(F, jb, !0), b = W.width();
                        a > b && F.css("minWidth", a)
                    }
                    F.css(mb), Y.css(mb), Y.append(G), H.before(eb), m()
                }
            }

            function v() {
                K && (K = !1, Q && F.width(ob), eb.detach(), F.prepend(G), F.css(nb), Y.css(nb), F.css("minWidth", pb), F.css("minWidth", g(F, jb)))
            }

            function w(a) {
                qb != a && (qb = a, F.triggerHandler("floatThead", [a, cb]))
            }

            function x(a) {
                Q != a && (Q = a, cb.css({position: Q ? "absolute" : "fixed"}))
            }

            function y(a, b, c, d) {
                return n ? c : d ? s.getSizingRow(a, b, c) : b
            }

            function z() {
                var a, b = t();
                return function () {
                    hb = $.find("col");
                    var c = y(F, hb, jb, j);
                    if (c.length == b && b > 0) {
                        if (!ab)for (a = 0; b > a; a++)hb.eq(a).css("width", "");
                        v();
                        var e = [];
                        for (a = 0; b > a; a++)e[a] = d(c.get(a));
                        for (a = 0; b > a; a++)ib.eq(a).width(e[a]), hb.eq(a).width(e[a]);
                        u()
                    } else Y.append(G), F.css(nb), Y.css(nb), m()
                }
            }

            function A(a) {
                var b = O.css("border-" + a + "-width"), c = 0;
                return b && ~b.indexOf("px") && (c = parseInt(b, 10)), c
            }

            function B() {
                var a, b = O.scrollTop(), c = 0, d = S ? R.outerHeight(!0) : 0, e = T ? d : -d, f = cb.height(), g = F.offset(), h = 0, i = 0;
                if (P) {
                    var j = O.offset();
                    c = g.top - j.top + b, S && T && (c += d), h = A("left"), i = A("top"), c -= i
                } else a = g.top - I - f + J + L.horizontal;
                var k = o.scrollTop(), m = o.scrollLeft(), n = O.scrollLeft();
                return function (j) {
                    var p = F[0].offsetWidth <= 0 && F[0].offsetHeight <= 0;
                    if (!p && db)return db = !1, setTimeout(function () {
                        F.triggerHandler("reflow")
                    }, 1), null;
                    if (p && (db = !0, !Q))return null;
                    if ("windowScroll" == j ? (k = o.scrollTop(), m = o.scrollLeft()) : "containerScroll" == j ? (b = O.scrollTop(), n = O.scrollLeft()) : "init" != j && (k = o.scrollTop(), m = o.scrollLeft(), b = O.scrollTop(), n = O.scrollLeft()), !l || !(0 > k || 0 > m)) {
                        if (X)x("windowScrollDone" == j ? !0 : !1); else if ("windowScrollDone" == j)return null;
                        g = F.offset(), S && T && (g.top += d);
                        var q, r, s = F.outerHeight();
                        if (P && Q) {
                            if (c >= b) {
                                var t = c - b + i;
                                q = t > 0 ? t : 0, w(!1)
                            } else q = V ? i : b, w(!0);
                            r = h
                        } else!P && Q ? (k > a + s + e ? q = s - f + e : g.top >= k + I ? (q = 0, v(), w(!1)) : (q = I + k - g.top + c + (T ? d : 0), u(), w(!0)), r = 0) : P && !Q ? (c > b || b - c > s ? (q = g.top - k, v(), w(!1)) : (q = g.top + b - k - c, u(), w(!0)), r = g.left + n - m) : P || Q || (k > a + s + e ? q = s + I - k + a + e : g.top > k + I ? (q = g.top - k, u(), w(!1)) : (q = I, w(!0)), r = g.left - m);
                        return {top: q, left: r}
                    }
                }
            }

            function C() {
                var a = null, b = null, c = null;
                return function (d, e, f) {
                    null == d || a == d.top && b == d.left || (cb.css({
                        top: d.top,
                        left: d.left
                    }), a = d.top, b = d.left), e && q(), f && m();
                    var g = O.scrollLeft();
                    Q && c == g || (cb.scrollLeft(g), c = g)
                }
            }

            function D() {
                if (O.length)if (O.data().perfectScrollbar)L = {horizontal: 0, vertical: 0}; else {
                    var a = O.width(), b = O.height(), c = F.height(), d = g(F, jb), e = d > a ? M : 0, f = c > b ? M : 0;
                    L.horizontal = d > a - f ? M : 0, L.vertical = c > b - e ? M : 0
                }
            }

            var E = h.uniqueId(), F = a(this);
            if (F.data("floatThead-attached"))return !0;
            if (!F.is("table"))throw new Error('jQuery.floatThead must be run on a table element. ex: $("table").floatThead();');
            i = s.autoReflow && i;
            var G = F.children("thead:first"), H = F.children("tbody:first");
            if (0 == G.length || 0 == H.length)return F.data("floatThead-lazy", s), void F.unbind("reflow").one("reflow", function () {
                F.floatThead(s)
            });
            F.data("floatThead-lazy") && F.unbind("reflow"), F.data("floatThead-lazy", !1);
            var I, J, K = !1, L = {
                vertical: 0,
                horizontal: 0
            }, M = e(), N = 0, O = s.scrollContainer(F) || a([]), P = O.length > 0, Q = null;
            "undefined" != typeof s.useAbsolutePositioning && (s.position = "auto", s.useAbsolutePositioning && (s.position = s.useAbsolutePositioning ? "absolute" : "fixed"), c("option 'useAbsolutePositioning' has been removed in v1.3.0, use `position:'" + s.position + "'` instead. See docs for more info: http://mkoryak.github.io/floatThead/#options")), "undefined" != typeof s.scrollingTop && (s.top = s.scrollingTop, c("option 'scrollingTop' has been renamed to 'top' in v1.3.0. See docs for more info: http://mkoryak.github.io/floatThead/#options")), "undefined" != typeof s.scrollingBottom && (s.bottom = s.scrollingBottom, c("option 'scrollingBottom' has been renamed to 'bottom' in v1.3.0. See docs for more info: http://mkoryak.github.io/floatThead/#options")), "auto" == s.position ? Q = null : "fixed" == s.position ? Q = !1 : "absolute" == s.position ? Q = !0 : s.debug && c('Invalid value given to "position" option, valid is "fixed", "absolute" and "auto". You passed: ', s.position), null == Q && (Q = P), Q || (K = !0);
            var R = F.find("caption"), S = 1 == R.length;
            if (S)var T = "top" === (R.css("caption-side") || R.attr("align") || "top");
            var U = a('<fthfoot style="display:table-footer-group;border-spacing:0;height:0;border-collapse:collapse;"/>'), V = !1, W = a([]), X = 9 >= j && !P && Q, Y = a("<table/>"), Z = a("<colgroup/>"), $ = F.children("colgroup:first"), ab = !0;
            0 == $.length && ($ = a("<colgroup/>"), ab = !1);
            var bb = a('<fthtr style="display:table-row;border-spacing:0;height:0;border-collapse:collapse"/>'), cb = a('<div style="overflow: hidden;" aria-hidden="true"></div>'), db = !1, eb = a("<thead/>"), fb = a('<tr class="size-row"/>'), gb = a([]), hb = a([]), ib = a([]), jb = a([]);
            eb.append(fb), F.prepend($), n && (U.append(bb), F.append(U)), Y.append(Z), cb.append(Y), s.copyTableClass && Y.attr("class", F.attr("class")), Y.attr({
                cellpadding: F.attr("cellpadding"),
                cellspacing: F.attr("cellspacing"),
                border: F.attr("border")
            });
            var kb = F.css("display");
            if (Y.css({
                    borderCollapse: F.css("borderCollapse"),
                    border: F.css("border"),
                    display: kb
                }), "none" == kb && (db = !0), Y.addClass(s.floatTableClass).css({
                    margin: 0,
                    "border-bottom-width": 0
                }), Q) {
                var lb = function (a, b) {
                    var c = a.css("position"), d = "relative" == c || "absolute" == c, e = a;
                    if (!d || b) {
                        var f = {paddingLeft: a.css("paddingLeft"), paddingRight: a.css("paddingRight")};
                        cb.css(f), e = a.data("floatThead-containerWrap") || a.wrap("<div class='" + s.floatWrapperClass + "' style='position: relative; clear:both;'></div>").parent(), a.data("floatThead-containerWrap", e), V = !0
                    }
                    return e
                };
                P ? (W = lb(O, !0), W.prepend(cb)) : (W = lb(F), F.before(cb))
            } else F.before(cb);
            cb.css({
                position: Q ? "absolute" : "fixed",
                marginTop: 0,
                top: Q ? 0 : "auto",
                zIndex: s.zIndex
            }), cb.addClass(s.floatContainerClass), r();
            var mb = {"table-layout": "fixed"}, nb = {"table-layout": F.css("tableLayout") || "auto"}, ob = F[0].style.width || "", pb = F.css("minWidth") || "", qb = !1;
            D();
            var rb, sb = function () {
                (rb = z())()
            };
            sb();
            var tb = B(), ub = C();
            ub(tb("init"), !0);
            var vb = h.debounce(function () {
                ub(tb("windowScrollDone"), !1)
            }, 1), wb = function () {
                ub(tb("windowScroll"), !1), X && vb()
            }, xb = function () {
                ub(tb("containerScroll"), !1)
            }, yb = function () {
                F.is(":hidden") || (r(), D(), sb(), tb = B(), (ub = C())(tb("resize"), !0, !0))
            }, zb = h.debounce(function () {
                F.is(":hidden") || (D(), r(), sb(), tb = B(), ub(tb("reflow"), !0))
            }, 1);
            if (P ? Q ? O.on(k("scroll"), xb) : (O.on(k("scroll"), xb), o.on(k("scroll"), wb)) : o.on(k("scroll"), wb), o.on(k("load"), zb), b(k("resize"), yb), F.on("reflow", zb), f(F) && F.on("filter", zb).on("sort", zb).on("page", zb), o.on(k("shown.bs.tab"), zb), o.on(k("tabsactivate"), zb), i) {
                var Ab = null;
                _.isFunction(s.autoReflow) && (Ab = s.autoReflow(F, O)), Ab || (Ab = O.length ? O[0] : F[0]), p = new MutationObserver(function (a) {
                    for (var b = function (a) {
                        return a && a[0] && ("THEAD" == a[0].nodeName || "TD" == a[0].nodeName || "TH" == a[0].nodeName)
                    }, c = 0; c < a.length; c++)if (!b(a[c].addedNodes) && !b(a[c].removedNodes)) {
                        zb();
                        break
                    }
                }), p.observe(Ab, {childList: !0, subtree: !0})
            }
            F.data("floatThead-attached", {
                destroy: function () {
                    var a = ".fth-" + E;
                    v(), F.css(nb), $.remove(), n && U.remove(), eb.parent().length && eb.replaceWith(G), i && (p.disconnect(), p = null), F.off("reflow"), O.off(a), V && (O.length ? O.unwrap() : F.unwrap()), P ? O.data("floatThead-containerWrap", !1) : F.data("floatThead-containerWrap", !1), F.css("minWidth", pb), cb.remove(), F.data("floatThead-attached", !1), o.off(a)
                }, reflow: function () {
                    zb()
                }, setHeaderHeight: function () {
                    m()
                }, getFloatContainer: function () {
                    return cb
                }, getRowGroups: function () {
                    return K ? cb.find(">table>thead").add(F.children("tbody,tfoot")) : F.children("thead,tbody,tfoot")
                }
            })
        }), this
    }
}(jQuery), function (a) {
    a.floatThead = a.floatThead || {}, a.floatThead._ = window._ || function () {
            var b = {}, c = Object.prototype.hasOwnProperty, d = ["Arguments", "Function", "String", "Number", "Date", "RegExp"];
            b.has = function (a, b) {
                return c.call(a, b)
            }, b.keys = function (a) {
                if (a !== Object(a))throw new TypeError("Invalid object");
                var c = [];
                for (var d in a)b.has(a, d) && c.push(d);
                return c
            };
            var e = 0;
            return b.uniqueId = function (a) {
                var b = ++e + "";
                return a ? a + b : b
            }, a.each(d, function () {
                var a = this;
                b["is" + a] = function (b) {
                    return Object.prototype.toString.call(b) == "[object " + a + "]"
                }
            }), b.debounce = function (a, b, c) {
                var d, e, f, g, h;
                return function () {
                    f = this, e = arguments, g = new Date;
                    var i = function () {
                        var j = new Date - g;
                        b > j ? d = setTimeout(i, b - j) : (d = null, c || (h = a.apply(f, e)))
                    }, j = c && !d;
                    return d || (d = setTimeout(i, b)), j && (h = a.apply(f, e)), h
                }
            }, b
        }()
}(jQuery);


var isTablet, isMobile900, isMobile;

if ($(document).width() <= 1024) {
    if ($(document).width() <= 900 && $(document).width() > 768) {
        isMobile900 = true;
    } else {
        isMobile900 = false;
    }
    if ($(document).width() > 768) {
        isTablet = true;
    } else {
        isTablet = false;
    }
    if ($(document).width() < 768) {
        isMobile = true;
    } else {
        isMobile = false;
    }
}

if (window.innerWidth < 768) {
    isMobile = true;
} else {
    isMobile = false;
}

function processAccHomeBanners() {
  if ($('body').hasClass('page-AccessoriesHomePage')) {
    $('.mini-banners').fadeIn(600);
    removeSpinnerStyles(".mini-banners img");
  }
}

$(document).on("load", processAccHomeBanners());

function removeSpinners(element){
  if(typeof element.data('src') !== 'undefined') {
    if (element.parent().parent() != undefined) {
      element.parent().parent().removeClass("invisible");
    }
    removeSpinnerStyles(element);
  }
}
function removeSpinnerStyles(element) {
  $(element).removeClass('spinner');
  $(element).removeClass('spinner-right');
  $(element).removeClass('spinner-sis-categ');
  $(element).removeClass('spinner-princ-banner');
}

// LazyLoad activation options.
var lazyLoadOptions = {
  callback_set: function(element) {
    $(element).removeAttr('data-was-processed');
    $(element).removeClass("loading");
    $(element).removeClass("error");
  },
  callback_load: function(element) {
    $(element).removeAttr('data-src');
    $(element).removeAttr('data-was-processed');
    $(element).removeClass("loaded");
    $(element).removeClass("error");
    removeSpinners($(element));
  },
  callback_enter: function(element) {
    if ($(element).data('src') == '') {
      $(element).attr("src", "");
    }
  }
};

// LazyLoad activation variable.
var activateLazyLoading= new LazyLoad(lazyLoadOptions);

// LazyLoad update
$(document).click(function() {
  activateLazyLoading.update();
});

$( document ).ajaxComplete(function() {
  activateLazyLoading.update();
});

$(".owl-carousel").on('changed.owl.carousel', function() {
  activateLazyLoading.update();
});

$(function () {

    // Breadcrumb
    $('.breadcrumb li:last-child a').on('click', function () {
        return false;
    });

    //Check to see if the window is top if not then display button
    $(window).scroll(function(){
        if ($(this).scrollTop() > 100) {
            $('.scrollToTop').fadeIn();
        } else {
            $('.scrollToTop').fadeOut();
        }
    });

    //Click event to scroll to top
    $('.scrollToTop').click(function(){
        $('html, body').animate({scrollTop : 0},1000);
        return false;
    });

    var toggleNav = $('.toggle-nav'),
        overlay = $('.overlay'),
        _search = $('.search'),
        _bannerProduct = $('.mini-banner-slider .item');


    var getBrowserWidth = function(){
        if(window.innerWidth < 768){
            // Small Device
            return "sm"
        } else if(window.innerWidth < 1023){
            // Medium Device
            return "md"
        } else {
            // Large Device
            return "lg"
        }
    };

    var device = getBrowserWidth();

    if(device === "sm"){

        // blocs carousel home
        var carouselSectionBlocs = $(".wrapper-cont-section ul");

        carouselSectionBlocs.owlCarousel({
            center: true,
            items: 1.12,
            loop: true,
            navigation : true,
            navRewind: false,
            pagination: false,
            nav: false,
            dots: false,
            rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false,
            responsiveRefreshRate : 100
        });

        // Carousel Home mobile
        var carouselSectionDyptique = $(".page-homepage .krups-push-wrapper .visuel-section > div").not('.style-best-seller .visuel-section > div');

        carouselSectionDyptique.owlCarousel({
            items: 1,
            loop: true,
            autoplay: true,
            autoplaySpeed: 1000,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            autoplayHoverPause: true,
            animateOut: 'fadeOut',
            animateIn: 'fadeIn',
            navRewind: false,
            pagination: false,
            dots: false,
            rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false,
            responsiveRefreshRate : 100
        });

        //Carousel about mobile
        var carouselAbout = $(".wrap-citations .citations-blocs");

        carouselAbout.owlCarousel({
            items: 1,
            loop: true,
            autoplay: true,
            autoplaySpeed: 5000,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            animateOut: 'fadeOut',
            animateIn: 'fadeIn',
            navigation : false,
            navRewind: false,
            pagination: false,
            nav: false,
            dots: false,
            responsiveRefreshRate : 100,
            touchDrag: false,
            rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false,
            mouseDrag: false
        });

        if ($(window).width() < 768) {
            $('.block-machine .block-machine-content .btn-gray').appendTo('.list-resipe-machine');
        }

        // block-machine carousel
        var carouselSectionBlocs = $(".list-resipe-machine");

        carouselSectionBlocs.owlCarousel({
            center: true,
            items: 1.12,
            margin: 12,
            navigation : true,
            navRewind: false,
            pagination: false,
            nav: false,
            rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false,
            dots: false,
            responsiveRefreshRate : 100
        });

    }

    //Main nav Mobile
    $('.main-nav .wrap-nav.mobile > .niv1>ul>li>a').not('.wrap-nav.mobile .direct-link a').on('click', function (e) {
        e.preventDefault();
        var cible = $(this).next();

        $('.main-nav .wrap-nav.mobile .niv2').slideUp();
        $('.main-nav .wrap-nav.mobile>.niv1>ul>li>a').removeClass('open');

        if (!$(cible).is(':visible')) {
            $(this).toggleClass("open");
            $(cible).slideToggle();
        }
    });

    $('.main-nav .wrap-nav.mobile .niv2>ul>li.has-children>a').on('click', function (e) {
        e.preventDefault();
        var cible = $(this).next();
        var text = $(this).html();

        $(cible).addClass("open-niv3");
        $('.main-nav .wrap-nav.mobile .niv3 .head a').html(text);
    });

    $('.main-nav .wrap-nav.mobile .niv3 .head a').on('click', function (e) {
        e.preventDefault();
        var cible = $(this).parents('.niv3');
        $(cible).removeClass("open-niv3");
    });

    // Carousel details product
    initProductViewer();
    jQuery('#ModalMedia').on('show.bs.modal', function () {
        $('body').addClass('open-popin');
    }).on('hidden.bs.modal', function () {
        $('body').removeClass('open-popin');
    });

    /* Hide modal-backdrop */
    $('#ModalPassword, .ConfModal').on('hidden.bs.modal', function () {
        $('.modal-backdrop').remove();
    });

    //Carousel home Recipe
    $(".wrap-home-recipe .krups-push-wrapper.recipe-section .list-home-recipe .item-recipe .visuel img").on('load', function () {
    	var carouselRecipe = $(".krups-push-wrapper .list-home-recipe");
        carouselRecipe.each( function(item) {
            $(this).owlCarousel({
                items: 1,
                loop: true,
                animateOut: 'fadeOut',
                animateIn: 'fadeIn',
                navigation : false,
                navRewind: false,
                pagination: false,
                nav: false,
                dots: false,
                responsiveRefreshRate : 100,
                touchDrag: false,
                rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false,
                mouseDrag: false
            });
        });
    });

    // Services carousel
    var carouselServices = $(".services ul");
    var carouselServicesOptions = {
        lazyLoad : true,
        margin: 0,
        navigation : true,
        navRewind: false,
        pagination: false,
        dots: false,
        rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false,
        responsiveRefreshRate : 100,
        responsive : {
            0 : {
                items: 2,
                center: true,
                mouseDrag: true,
                adaptiveHeight: true,
                loop: true
            },
            768 : {
                items: 5,
                slideBy: 5,
                center: false,
                mouseDrag: false,
                adaptiveHeight: false,
                loop: true
            }
        }
    };
    carouselServices.each( function(item) {
        var $this = $(this);
        var item_amount = parseInt($this.find('.item').length);
        carouselServicesOptions.nav = item_amount > 5;
        if (!!CarouselUtils.getCurrentBreakPoint()) {
            $this.on("initialize.owl.carousel", function (event) {
                // console.log('initialize.owl.carousel', this);
                CarouselUtils.initinitializeOwlCarousel($this, '.item', carouselServicesOptions.responsive, [768])
            });
        }
        $this.owlCarousel(carouselServicesOptions);
    });

    // Documentation
    var carouselServices = $(".content-notices .list-doc");
    var carouselServicesOptions = {
        loop: true,
        lazyLoad : true,
        margin: 0,
        navigation : true,
        navRewind: false,
        pagination: false,
        dots: false,
        rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false,
        responsiveRefreshRate : 100,
        responsive : {
            0 : {
                items: 2,
                slideBy: 2,
                mouseDrag: true,
                adaptiveHeight: true
            },
            768 : {
                items: 5,
                slideBy: 5,
                center: false,
                mouseDrag: false,
                adaptiveHeight: false
            }
        }
    };

    carouselServices.each( function(item) {
        var $this = $(this);
        var item_amount = parseInt($this.find('.item').length);
        carouselServicesOptions.nav = item_amount > 5;
        carouselServicesOptions.responsive[0].center = item_amount > 3;
        if (item_amount > 3) {
            $this.on("initialize.owl.carousel", function(event) {
                // console.log('initialize.owl.carousel', this);
                CarouselUtils.initinitializeOwlCarousel($this, '.item', carouselServicesOptions.responsive, [768])
            });
        }
        $this.owlCarousel(carouselServicesOptions);
    });

    // Carousel Recipe
    var recipeCarousel = $('.recipe-carousel ul');
    recipeCarousel.each( function(item) {
        var item_amount = parseInt( $(this).find('.item').length);
        var hasDesigned = $(this).parents('.designed');
        var carouselDots = false;
        if($('#CarouselRecettesPreferees').length > 0) {
            carouselDots = true
        }
        $(this).owlCarousel({
            items: 3,
            slideBy: 3,
            margin: 20,
            lazyLoad: true,
            pagination: false,
            nav: item_amount > 3 ? true:false,
            dots: carouselDots,
            rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false,
            responsiveRefreshRate: 100,
            responsive : {
                0 : {
                    items:  hasDesigned.length > 0 ? 1.5:1.18 ,
                    slideBy: hasDesigned.length > 0 ? 1.5:1.18 ,
                    center: item_amount > 1 ? true:false,
                    mouseDrag: true,
                    autoHeight: true,
                    adaptiveHeight: true,
                    loop: true
                },
                768 : {
                    items: 3,
                    slideBy: 3,
                    center: false,
                    autoHeight: false,
                    mouseDrag: false,
                    adaptiveHeight: false,
                    loop: item_amount > 3 ? true:false
                }
            }
        });

        if($(this).find('.owl-dots .owl-dot').length == 1) {
            $(this).find('.owl-dots').remove();
        }
    });

    // Refresh Recipe
    $.fn.rotate = function (degrees, options) {

        var settings = $.extend({}, $.fn.rotate.defaults, options),
            endDeg = 0;

        degrees = degrees || $.fn.rotate.degrees;

        return this.each(function (i, el) {
            if ($(el).is(':animated')) {
                return;
            }

            endDeg = (el.deg || endDeg) + degrees;
            settings.step = function (now) {
                $(el).css('transform', 'rotate(' + now + 'deg)');
                $(el).css('-webkit-transform', 'rotate(' + now + 'deg)');
            };

            $(el).animate({
                deg: endDeg
            }, settings);
        });

    };

    $(document).on('click', '.load-recipe', function (e) {
        e.preventDefault();
        $(this).parent().find('.list-home-recipe').trigger('next.owl.carousel');
        $(this).find('span').rotate(360, {
            duration: 500,
            easing: 'linear'
        });
        // lazy loading
        var recipes;
        var currentLoader=$(this);
        var currentRecipe=currentLoader.parent().find('.list-home-recipe').find(".owl-stage .active .item-recipe");
        if(currentRecipe && currentRecipe.hasClass("loadNext")){
            var url = currentLoader.parent().find('.home-btn-search-more').attr("href");
            currentRecipe.removeClass("loadNext");
            if(typeof  url !== 'undefined'){
                $.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'html',
                    data: ''
                }).always(function (data) {
                  recipes = $.parseHTML(data);
                  var $content = currentLoader.prev().find('.cont-section');
                  $.each( recipes, function( i, el ) {
                    if(el.outerHTML && typeof  el.outerHTML !== 'undefined' && $(el.outerHTML).filter('a.next-search-more').length==0) {
                      currentLoader.parent().find('.list-home-recipe').trigger('add.owl.carousel', el.outerHTML);
                    }
                    if ($(window).width() < 768) {
                      var contRecipe = $(recipes).find('.caption');
                      if(!$(recipes).find('.caption .cont-section').length >0){
                        $content.clone().prependTo(contRecipe);
                      }
                    }
                  });
                  currentLoader.parent().find('.list-home-recipe').trigger('refresh.owl.carousel');
                  coverImageProcess(currentLoader.parent().find('.list-home-recipe'));

                  if($(data).filter('a.next-search-more').length >0){
                    var newUrl=$(data).filter('a.next-search-more').attr("href");
                    currentLoader.parent().find('.home-btn-search-more').attr("href",newUrl);
                    currentLoader.parent().find('a.next-search-more').remove();
                  }else{
                    currentLoader.parent().find('.home-btn-search-more').remove();
                  }
                });
            }
        }
    })


    // init mini banners carousel
    if (window.innerWidth < 768) {
        isMobile = true;
    } else {
        isMobile = false;
    }

    var carouselMiniBanners = $(".category-page .mini-banners .container .banners-right");

    if (true == isMobile) {
        $(".category-page .mini-banners .container .banners-left").hide();

        $(".category-page .mini-banners .container .banners-right .push-banner-to-hide").addClass( "banner" );
        $(".category-page .mini-banners .container .banners-right .push-banner-to-hide").show();
        carouselMiniBanners.owlCarousel({
            items: 1,
            loop: false,
            lazyLoad : true,
            navRewind: false,
            pagination: false,
            nav: false,
            dots: true,
            rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false,
            mouseDrag: true
        });
    }

    $(document).on('change', '.pager select', function (event) {
        var url = $(this).val();
        document.location.href = url;
    });

    if (true == isMobile) {
        // BRA-22274
        $('.collapse:not(#search-list-page--filters-container .collapse)').removeClass('in');
        $('.accordion-toggle.active:not(#search-list-page--filters-container .accordion-toggle.active)').removeClass('active').addClass('collapsed');
        $('[data-toggle="collapse"]:not(#search-list-page--filters-container [data-toggle="collapse"])').addClass('collapsed');
        $('.targeter').on('click', function () {
            $(this).next('.collapse').collapse('toggle');
            $(this).toggleClass('targeter-active');
        });
    }

    if (isMobile != true) {
        /* Sticky head table comparison */
        var $table = $('#ScrollabeTableCompare');

        var headHeightToFixTable = $(".wrap-header header").outerHeight() + 45;
        var menuStikyProductToFixTable = 0, navLameFixedToFixTable = 0;
        if($(".sticky-boutons .container")){
            menuStikyProductToFixTable = $(".sticky-boutons .container").outerHeight();
        }
        if($(".snav_lame")){
            navLameFixedToFixTable = $(".nav_lame").outerHeight();
        }

        var positionToFixTable = headHeightToFixTable + menuStikyProductToFixTable + navLameFixedToFixTable;

        $table.floatThead({
            top: positionToFixTable - 53,
            zIndex: 10
        });
    }

    bindCreateUpdateAddress();

    if (!isMobile && $('body.page-SubCategoryPage').length > 0) {
        $('.page-ifu-categories-list #ifu-search + .item > .filter-list').hide();
        var toggleAcc = $('.sidebar-filters .filters > .item:first-child:not(#rp-search, #faq-search, #accessoryProduct-search, #ifu-search)');
        toggleAcc.addClass('toggle head');
        if (toggleAcc.siblings().is(':visible')) {
            $('.sidebar-filters .filters').addClass('open');
        }
        toggleAcc.on('click', function () {
            toggleAcc.siblings().stop(true, true).slideToggle(300);
            $(this).parent().toggleClass('open');
        });
    }
    if (isMobile == true || $(window).width() <= 768) {
        var handler=('ontouchstart' in document.documentElement ? "touchstart" : "click");
        // menu mon compte
        $('.page-ifu-categories-list #ifu-search + .item > .filter-list').hide();
        var toggleAcc = $('.sidebar-filters .filters > .item:first-child:not(#rp-search, #faq-search, #accessoryProduct-search, #ifu-search)');
        toggleAcc.addClass('toggle head');
        toggleAcc.siblings().hide();
        //$('.sidebar-filters .filters .item:not(.toggle)').hide();
        if (toggleAcc.siblings().is(':visible')) {
            $('.sidebar-filters .filters').addClass('open');
        }
        $(document).on(handler, '.toggle', function () {
            toggleAcc.siblings().stop(true, true).slideToggle(300);
            $(this).parent().toggleClass('open');
        });
        $('.page-faq-categories-list .sidebar-filters .accordion-body, .page-ifu-categories-list .sidebar-filters .accordion-body, .page-AccessoryListPage .sidebar-filters .toggle2 + .accordion-body, .page-AccessoryFinishedProductDetailPage .sidebar-filters .accordion-body').removeClass('collapse');


        $(document).on(handler, '.toggle2', function (e) {
            e.preventDefault();
            $(this).next('.accordion-body').stop(true, true).slideToggle(300);
            $(this).parent().toggleClass('open');
        });


        var toggleAcc3 = $('#accessoryProduct-search .filter-list .name, #ifu-search .filter-list .name');
        toggleAcc3.addClass('toggle3');
        toggleAcc3.siblings().hide();

        $(document).on(handler, '.toggle3', function (e) {
            e.preventDefault();
            $('.sidebar-filters .search').stop(true, true).slideToggle(300);
            $(this).parent().toggleClass('open');
        });

        $('.page-ifu-categories-list #ifu-search > div > div.name.toggle3').show();

        $('.accordion-panel').not('.content-mosaic-ban .accordion-panel').each(function () {
            var accordionPanelHeiht = $(this).height(),
                element = $(this);
            if ( element.find("h2:first-child").length ) {
                elementTitle = element.find("h2:first-child");
            }else{
                elementTitle = element.find(".accordion-panel-title");
            }

            titleHeiht = elementTitle.outerHeight();

            element.height(titleHeiht).addClass('active');

            elementTitle.on('click', function (e) {
                e.preventDefault();
                element.toggleClass('open');
                //tog.height(accordionPanelHeiht);
                if(element.hasClass('open') && !element.hasClass('colspad') ){
                    $(this).addClass('active');
                    element.addClass('colspad');
                    element.animate({
                        height: accordionPanelHeiht
                    }, 600, function() {
                        element.css('height', 'auto');
                        element.removeClass('colspad');
                    });

                }else if(!element.hasClass('colspad')){
                    $(this).removeClass('active');

                    element.addClass('colspad');
                    element.animate({
                        height: $(this).outerHeight()
                    }, 500, function() {
                        element.removeClass('colspad');
                    });
                }

            });

        });

        $('.mosaic-ban .content-mosaic-ban > div .content-popine').hide();
        $(".mosaic-ban .content-mosaic-ban>div .accordion-panel-title").click(function(e) {
            var cible = $(this).parents(".content-ombre").find(".content-popine");

            $('.mosaic-ban .content-mosaic-ban > div .content-popine').slideUp();
            $('.mosaic-ban .content-mosaic-ban>div .accordion-panel-title').removeClass('active');

            if (!$(cible).is(':visible')) {
                $(this).toggleClass("active");
                $(cible).slideToggle();
            }
        });

        var toggleAcc4 = $('.filters-faq #accordionFiltersFaq .accordion-heading a');
        toggleAcc4.addClass('toggle4');
        $('.filters-faq #accordionFiltersFaq .accordion-body').removeClass('in collapse').hide();

        $(document).on('touchstart', '.toggle4', function (e) {
            e.preventDefault();
            $('.filters-faq #accordionFiltersFaq .accordion-body').stop(true, true).slideToggle(300);
            $(this).parent().toggleClass('open');
        });


        $('.list-product .row-fluid.bloc-seo + .zone-compare').appendTo('.list-product .span3');

    }


    if ($('html').hasClass('lt-ie9')) IE();

    toggleNav.on('click touchstart', function (e) {
        $('.modal-backdrop').remove();
        if($('.krups-animate').length) {
            $.fn.fullpage.setMouseWheelScrolling(true);
            $.fn.fullpage.setAllowScrolling(true);
        }
        openNav();
        openFirstAccordion();
        e.preventDefault();
    });

    $('.main-nav .accordion-inner > ul > li:not(".direct-link") > a').on('click touchend', function (e) {
        e.preventDefault();
        if (!$(this).parent().hasClass('direct-link')) {
            if (!$(this).parents('.niv2').length) {
                toggleniv2($(this));
            }
        }
    });

    function openFirstAccordion() {
        var first_accordion_group = $('.main-nav .navigation .accordion-group').first();
        var all_accordion_group = $('.main-nav .navigation .accordion-group');
        all_accordion_group.find('.accordion-body').css('height', '0').removeClass('in');
        all_accordion_group.find('.accordion-toggle').removeClass('active');
        first_accordion_group.find('.accordion-body').css('height', 'auto').addClass('in');
        first_accordion_group.find('.accordion-toggle').removeClass('collapsed').addClass('active');
    }

    $('.mobile-back').on('click touchstart', function (e) {
        e.preventDefault();
        $('.niv2').removeClass('open');
        $('.niv1 .actif').removeClass('actif');
        $(this).removeClass('back');
    });

    $("header .search form[name='search_form']").submit(function(event){
    	var minLength = parseInt(ACC.searchTextMinLength);
    	if($("header .search #search").val().length < minLength) {
    		event.preventDefault();
    	}
    });

    overlay.on('click', function (e) {
        $('.mobile-back').removeClass('back')
        openNav();
    });

    $('.dropdown-toggle').dropdown();

    if ($('.country').length) {
        $('.country > a').dropdown()
    }
    if ($('.page-homepage').length) {
        if (isMobile) {
            $('.master-slider .simple-slider').remove();
        } else {
            $('.master-slider .mobile-carousel').remove();
        }
    }

    var simpleSlider;
    $('.js-carousel').each(function () {
        var $slider = $(this);
        var sliderOptions = {
            controls: false,
            infiniteLoop: true,
            auto: true,
            pause: $slider.data('interval') || 9000,
            adaptiveHeight: true,
            autoHover: true
        };
        if (isMobile) {
            sliderOptions.onSliderLoad = function (currentIndex) {
                $slider.parents('.bx-wrapper').addClass('simpleSlider-wrapper mobile-slider');
                $('.mobile-simple-slider .item').css('display', 'block');
            };
        } else {
            sliderOptions.onSliderLoad = function (currentIndex) {
                $slider.parents('.bx-wrapper').addClass('simpleSlider-wrapper');
                $('.simple-slider .item').css('display', 'block');

            };
            if ($('.page-homepage').length) {
                sliderOptions.slideWidth = 1280;
            }
        }
        simpleSlider = $slider.bxSlider(sliderOptions);
    });

    /* Satisfaction FAQ */
    $('input[type=radio][name=notation]').change(function () {
        var $notationForm = $(this).parents('.notation');
        $notationForm.find('input[type=submit]').prop("disabled", false);
        if ($('input[name=notation]:checked', $notationForm).val() == "false") {
            $notationForm.find('.amelioration').removeClass('hidden');
            $notationForm.find('#or').removeClass('hidden');
            $notationForm.find('#contactUs').removeClass('hidden');
        } else {
            $notationForm.find('.amelioration').addClass('hidden');
            $notationForm.find('#or').addClass('hidden');
            $notationForm.find('#contactUs').addClass('hidden');
        }
    });

    $(".notationForm").each(function () {
        $(this).on('submit', function (e) {
            e.preventDefault();

            var $this = $(this);
            var faqUtile = $this.find('.faqUtile:checked').val();
            //var amelioration = "";

            if (faqUtile === '') {
                //console.log('Les champs doivent êtres remplis');
            } else {
                /*if (faqUtile == "false") {
                 amelioration = $('.ameliorationInput:checked', $this).val();
                 } else {
                 amelioration = '';
                 }*/

                $this.addClass('hidden');
                $this.parents('.notation').find('.thanks').removeClass('hidden');

                $.ajax({
                    url: $this.attr('action'),
                    type: $this.attr('method'),
                    data: $this.serialize()
                }).done( function (html) {
                        //console.log(html)
                });


            }
        });
    });

    $(window).on('load',function () {

        // Features slider
        var featuresSlider = $(".features-slider");
        var featuresSliderOptions = {
            items: 3,
            slideBy: 3,
            loop: true,
            margin: 24,
            lazyLoad: true,
            pagination: false,
            dots: false,
            rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false,
            responsiveRefreshRate: 100,
            responsive : {
                0 : {
                    items: 1,
                    slideBy: 1,
                    mouseDrag: true,
                    autoHeight: true,
                    dots: true
                },
                768 : {
                    items: 3,
                    slideBy: 3,
                    autoHeight: false,
                    dots: false,
                    mouseDrag: false
                }
            }
        };

        featuresSlider.each( function(item) {
            var $this = $(this);
            var item_amount = parseInt($this.find('.item').length);
            featuresSliderOptions.nav = item_amount > 3;
            $this.on("initialize.owl.carousel", function(event) {
                // console.log('initialize.owl.carousel', this);
                CarouselUtils.initinitializeOwlCarousel($this, '.item', featuresSliderOptions.responsive, [768])
            });
            $this.owlCarousel(featuresSliderOptions);
        });

        // Slider 4 items
        var slider4 = $('.slider-4:not("[data-slider]")');
        var slider4Options = {
            items: 4,
            slideBy: 4,
            margin: 12,
            lazyLoad: true,
            pagination: false,
            dots: false,
            rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false,
            responsiveRefreshRate: 100,
            responsive : {
                0 : {
                    // items:  hasDesigned.length > 0 ? 1.5:1.18,
                    // slideBy: hasDesigned.length > 0 ? 1.5:1.18,
                    // center:  item_amount > 1 ? true:false,
                    mouseDrag: true,
                    autoHeight: true,
                    adaptiveHeight: true,
                    loop: true
                },
                768 : {
                    items: 4,
                    center: false,
                    autoHeight: false,
                    mouseDrag: false,
                    adaptiveHeight: false,
                    loop: false
                }
            }
        };
        slider4.each( function(item) {
            var $this = $(this);
            var item_amount = parseInt($this.find('.item').length);
            var hasDesigned = $this.parents('.designed');
            var isGreatThan4 = item_amount > 4;
            slider4Options.nav = isGreatThan4;
            slider4Options.responsive[0].items = hasDesigned.length > 0 ? 1.5:1.18;
            slider4Options.responsive[0].slideBy = hasDesigned.length > 0 ? 1.5:1.18;
            slider4Options.responsive[0].center = item_amount > 1;
            if (isGreatThan4 && !!CarouselUtils.getCurrentBreakPoint()) {
                slider4Options.responsive[768].slideBy= 4;
                slider4Options.responsive[768].loop = true;
                $this.on("initialize.owl.carousel", function (event) {
                    CarouselUtils.initinitializeOwlCarousel($this, '.item', slider4Options.responsive, [768])
                });
            }
            $this.owlCarousel(slider4Options);
        });

      $(function () {
        $("[data-slider]").each(function (index, slider) {
          var locked = false;
          var self = $(slider);
          var accessoryCode = self.data("slider-main-accessory");
          var sliderPageSize;
          var asyncOptions = {
            rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false,
            responsiveRefreshRate: 100,
            stageElement: "ul",
            itemElement: "li",
            loop: false,
            nav: true,
            dots: false,
            mouseDrag: false,
            touchDrag: false,
            lazyLoad: true,
            margin: 12,
            items: 4,
            slideBy: 4,
            responsive: {
              0: {
                items: 1,
                slideBy: 1,
                center: false,
                mouseDrag: true,
                autoHeight: true,
                adaptiveHeight: true
              },
              768: {
                items: 4,
                slideBy: 4,
                center: false,
                autoHeight: false,
                mouseDrag: false,
                adaptiveHeight: false,
                loop: false
              }
            }
          };
          switch (GSEB.functions.responsiveValue()) {
            case "mobile":
              sliderPageSize = parseInt(self.attr("data-slider-page-size-mobile"));
              break;
            case "tablet":
              sliderPageSize = parseInt(self.attr("data-slider-page-size-tablet"));
              break;
            case "desktop":
              sliderPageSize = parseInt(self.attr("data-slider-page-size-desktop"));
              break;
          }

          self.on("initialized.owl.carousel", function () {
            self.find(".owl-stage-outer").addClass("slider-4-wrapper");
            self.closest("#AccessoriesPush, .recipe-product-made .slider-4").css("overflow", "visible");
            self.parent().find(".spinner").remove();
            self.removeClass("invisible");
          });

          $.post(GSEB.urls.otherRecommendedAccessories, {
            accessoryCode: accessoryCode,
            page: 0,
            pageSize: sliderPageSize,
            beforeSend: function () {
              self.block({
                message: '<div align="center" class="spinner"><img src="/_ui/desktop/common/img/img-defer-spinner.svg"/></div>',
                overlayCSS: {
                  'backgroundColor': '#000',
                  'opacity': 0.2,
                  'cursor': 'wait',
                  'z-index': 200,
                },
                css: {
                  'z-index': 205,
                  'border': 0,
                  'background-color': 'transparent'
                }
              });
            }
          }).done(function (data) {
            self.attr("data-slider-total-pages", $(data).data("slider-total-pages"));
            self.html($(data).find(".item"));
            self.find("button.add-to-cart").attr("type", "submit");
            self.owlCarousel(asyncOptions);
          }).fail(function (data) {
            //LOG error message
          }).always(function () {
            if (self.attr("data-slider-current-page") < parseInt(self.attr("data-slider-total-pages")) - 1) {
              self.find(".owl-nav").removeClass("disabled");
              self.find(".owl-nav .owl-next").removeClass("disabled");
            }
            self.unblock();
          });

          self.on("click", ".owl-nav .owl-next", function (event) {
            self.find(".owl-nav .owl-next").addClass("disabled");
            if (self.attr("data-slider-current-page") < parseInt(self.attr("data-slider-total-pages")) - 1 && locked === false) {
              if (self.attr("data-slider-current-page") === self.attr("data-slider-loaded-pages")) {
                locked = true;

                $.post(GSEB.urls.otherRecommendedAccessories, {
                  accessoryCode: accessoryCode,
                  page: parseInt(self.attr("data-slider-current-page")) + 1,
                  pageSize: sliderPageSize,
                  beforeSend: function () {
                    self.block({
                      message: '<div align="center" class="spinner"><img src="/_ui/desktop/common/img/img-defer-spinner.svg"/></div>',
                      overlayCSS: {
                        'backgroundColor': '#000',
                        'opacity': 0.2,
                        'cursor': 'wait',
                        'z-index': 200,
                      },
                      css: {
                        'z-index': 205,
                        'border': 0,
                        'background-color': 'transparent'
                      }
                    });
                  }
                })
                  .done(function (data) {
                    $(data).find(".item").each(function (index, product) {
                      self.trigger("add.owl.carousel", product);
                    });
                    self.find("button.add-to-cart").attr("type", "submit");
                    self.trigger("refresh.owl.carousel");
                    self.trigger("next.owl.carousel");
                    self.attr("data-slider-loaded-pages", parseInt(self.attr("data-slider-loaded-pages")) + 1);
                    //Check if Rebind all JS events is necessary (analytics, etc.)
                  })
                  .fail(function (error) {
                    // LOG an error message
                  })
                  .always(function () {
                    self.unblock();
                  });
              }
              self.attr("data-slider-current-page", parseInt(self.attr("data-slider-current-page")) + 1);
            }
          });
          self.on("click", ".owl-nav .owl-prev", function (event) {
            self.find(".owl-nav .owl-prev").addClass("disabled");
            if (self.attr("data-slider-current-page") > 0) {
              self.attr("data-slider-current-page", parseInt(self.attr("data-slider-current-page")) - 1);
            }
          });
          self.on("translated.owl.carousel", function () {
            if (self.attr("data-slider-current-page") < parseInt(self.attr("data-slider-total-pages")) - 1) {
              self.find(".owl-nav .owl-next").removeClass("disabled");
            }
            if (self.attr("data-slider-current-page") > 0) {
              self.find(".owl-nav .owl-prev").removeClass("disabled");
            }
            locked = false;
          });

        });
      });


        featuresSlider.find('.owl-item').each(function (index) {
            $(this).find('.desc').readmore({
                speed: 75,
                collapsedHeight: 80,
                lessLink: '',
                moreLink: '<a href="#" class="read-more">'+readMoreButton+'</a>'
            });
        });


        //remove spinners
        featuresSlider.parent().find(".spinner").remove();
        slider4.parent().find(".spinner").remove();

        //show hidden lazy element after load
        featuresSlider.removeClass("invisible");
        slider4.removeClass("invisible");


        /* Gestion du titre de la page Cookboard si'il est trop grand*/

        if ($('.wrap-cookboard').length) {
            if ($('h1', $('.wrap-title')).width() > 145) {
                $('.wrap-title').css({
                    'width': $('h1').width() + 30,
                    'height': $('h1').width() + 30
                })
            } else if ($('h1', $('.wrap-title')).height() > 145) {
                $('.wrap-title').css({
                    'width': $('h1').height() + 30,
                    'height': $('h1').height() + 30
                })
            }
        }

        $('#ifuLanguage').change(
            function () {
                $(this).closest('form').trigger('submit');
            }
        );

        $('#ifuSelector').submit(
            function (e) {
                e.preventDefault();
                if (typeof slider5 != 'undefined') {
                    slider5.trigger("destroy.owl.carousel");
                }
                showLoader();
                jQuery.ajax({
                    data: $('#ifuSelector').serialize(),
                    url: $('#ifuSelector').attr('action')
                }).done(function (html) {
                    $(".documentation .owl-carousel").html(html);

                    slider5 = $(".documentation .owl-carousel .slider-5 .scroll")

                    var item_amount = parseInt(slider5.find('.item').length);
                    var slider5Options = {
                        loop: true,
                        lazyLoad : true,
                        margin: 0,
                        navigation : true,
                        navRewind: false,
                        pagination: false,
                        rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false,
                        nav: item_amount > 5 ? true:false,
                        dots: false,
                        responsiveRefreshRate : 100,
                        responsive : {
                            0 : {
                                items: 2,
                                slideBy: 2,
                                center: item_amount > 3 ? true:false,
                                mouseDrag: true,
                                adaptiveHeight: true
                            },
                            768 : {
                                items: 5,
                                slideBy: 5,
                                center: false,
                                mouseDrag: false,
                                adaptiveHeight: false
                            }
                        }
                    };
                    slider5.on("initialize.owl.carousel", function(event) {
                        // console.log('initialize.owl.carousel', this);
                        CarouselUtils.initinitializeOwlCarousel(slider5, '.item', slider5Options.responsive, [768])
                    });
                    slider5.owlCarousel(slider5Options);
                    //Analytic.bindAllEvents();
                    hideLoader();
                });
            }
        );

        if (isMobile != true && isTablet != true && $("#video-wrapper").length) {
            if (typeof YTapiKey !== 'undefined') {
                apikey = YTapiKey;
            } else {
                apikey = "AIzaSyDGtQWD7yn7cbeY9uN-1kVLP2KHyAa0fZg";
            }
            /**
             *
             * @type {*|jQuery}
             */
            var myVideo = $("#video-wrapper").YTPlayer({
                apiKey: apikey
            });
            myVideo.on("YTPStart", function () {
                $('.motion-component .bg-cover').addClass('is-playing');
            });
            myVideo.on("YTPEnd", function () {
                $('.motion-component .bg-cover').removeClass('is-playing');
            });
        }
    });

    // incription a la newsLetter apres la creation du compte
    if ($("#ModalNewsLetter.my-space").length > 0) {
        $('#ModalNewsLetter.my-space').modal();
    }

    /* BRA-4352 */
    function processModalMediaIndexes () { // open selected media in thumbnails not always the first element
        var thumbnails = $ ( '.page-productDetails #CarouselDetailProduct .thumbnails .thumbnail a' );
        thumbnails.each ( function () {
            var thumbnail = $ ( this ).find ( 'img' );
            var thumbnail_index = thumbnail.attr ( 'data-galleryposition' );
            thumbnail.click ( function () {
                $ ( document ).trigger ( 'modalMediaOpenedWithIndex', thumbnail_index );
            } );
        } );
        $ ( document ).on ( 'modalMediaOpenedWithIndex', function ( event, index ) {
            startSlide = index;
        } );
    }

    processModalMediaIndexes();

    ////settings minicart scroll NECESSAIRE MAIS DEJA DANS LES FICHIERS D'HYBBRIS ACC.....
    if ($('.cart_popup .scroll ul li').length > 3) {
        $('.cart_popup .scroll').slimScroll({
            height: Math.min(370,$(window).height() - 300),//$('.actions').height(),
            alwaysVisible: false,
            allowPageScroll: false,
            position: 'right',
            color: '#ED1C24',
            distance: '4px',
            railVisible: true,
            wheelStep: 10,
            opacity: 1
        });
    }

    $('.accordion-group').on('shown', function (e) {
        e.stopPropagation();
        $(e.target).prev('.accordion-heading').find('.accordion-toggle').addClass('active');
    });

    $('.accordion-group').on('hidden', function (e) {
        e.stopPropagation();
        $(this).find('.accordion-toggle').not($(e.target)).removeClass('active');
    });

    $('.main-nav .navigation .accordion-group').on('hidden', function (e) {
        $(this).find('a').removeClass('actif').end().find('.niv2').removeClass('open');
    })


    /* SMOOTH SCROLL on anchor click */
    $('.logo a[href*=\\#]:not([href=\\#]), a.anchor[href*=\\#]:not([href=\\#])').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top - 115
                }, 900);
                return false;
            }
        }
    });

    /* Placeholder fix */
    if (Modernizr.input && !Modernizr.input.placeholder) {
        $('[placeholder]').focus(function () {
            var input = $(this);
            if (input.val() == input.attr('placeholder')) {
                input.val('');
                input.removeClass('placeholder');
            }
        }).blur(function () {
            var input = $(this);
            if (input.val() == '' || input.val() == input.attr('placeholder')) {
                input.addClass('placeholder');
                input.val(input.attr('placeholder'));
            }
        }).blur();
        $('[placeholder]').parents('form').submit(function () {
            $(this).find('[placeholder]').each(function () {
                var input = $(this);
                if (input.val() == input.attr('placeholder')) {
                    input.val('');
                }
            })
        });
    }

    //init scrollable compare array in product detail page
    scrollableTable();

    if ($('.krups-products-list').length) {
        refresh_compare();
        //add custom action on go compare
        initGoCompare(maxCheckError, minCheckError);
    }

    $('.disabled').on('click', function (e) {
        e.preventDefault();
    });

    if ($('.iCheck').length) {
        $('input[type=CHECKBOX]', $('.filters')).iCheck();
        $('input[type=CHECKBOX]', $('.filters')).on('ifChanged', function () {
            $(this).closest('form').submit()
        });
    }

    HighlightAutocomplete();
    /* Code temporaire seulement pour la démo de l'autocomplete */
    /* on vous prie de bien vouloir nettoyer le code
     * Merci d'avance.
     */

    /* iPad Hack to avoid two click instead of one*/

    $('.ui-autocomplete').on('touchstart', 'li.ui-menu-item', function () {

        var $container = $(this).closest('.ui-autocomplete'),
            $item = $(this);

        //if we haven't closed the result box like we should have, simulate a click on the element they tapped on.
        function fixitifitneedsit() {
            if ($container.is(':visible') && $item.hasClass('ui-state-focus')) {

                $item.trigger('click');
                return true; // it needed it
            }
            return false; // it didn't
        }

        setTimeout(function () {
            if (!fixitifitneedsit()) {
                setTimeout(fixitifitneedsit, 600);
            }
        }, 600);
    });

    /* fin demo autocomplete*/

    $('.nl-reset').on('click', function (event) {
        event.preventDefault();
        nlReset();
    });

    //close modal IE Managment
    $('.master-detail-product .modal').on('hidden', function () {
        var iframe = $(this).children('div.modal-body').find('iframe');
        iframe.attr('src', '');
        $(this).removeData();
    });

    //close modal IE Managment
    $('#ModalCommerce').on('shown', function () {
        $(this).find('.modal-body').css({
            'max-height': '100%'
        });
    });


    // Moulisearch - SEE MORE handler
    handleMoulisearchLoad();


    // List product - SEE MORE handler
    $(document).on('click', '.list-recipe .more a', function (event) {
        $('.more').hide();
        var url = $(this).attr("href");
        event.preventDefault();
        showLoader();
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'html',
            data: ''
        }
            ).always(function (data) {
               $('#grid').append(data);
               $('.list-recipe').append($("div.more"));
               new GridScrollFx(document.getElementById('grid'));
               hideLoader();
        });
    });

    $(document).on('click', '.filters a.tooltip-bottom', function (event) {
        var activeClass = $(this).hasClass("active");

        if(activeClass){
            $(this).removeClass("active");
            if($(this).hasClass("seeAll")){
                $("a.tooltip-bottom").removeClass("active");
            }
            if($("a.tooltip-bottom.active").not(".seeAll").length!=$("a.tooltip-bottom").not(".seeAll").length){
                $("a.tooltip-bottom.seeAll").removeClass("active");
            }
        }else{

            if($(this).hasClass("seeAll")){
                $("a.tooltip-bottom").addClass("active");
            }else{
                $(this).addClass("active");
                if($("a.tooltip-bottom.active").not(".seeAll").length==$("a.tooltip-bottom").not(".seeAll").length){
                    $("a.tooltip-bottom.seeAll").addClass("active");
                }
            }
        }

        recipes_form_query_constructor();
        event.preventDefault();
    });


    if ($('.list-news').length) {
        // List product - SEE MORE handler
        //var nblishown = 4,
        var nblitoshow = 5;

        $('.list-news ul li:nth-child(' + nblishown + ') ~ li').addClass('hidden');
        $(document).on('click', '.list-news .show-more a', function (event) {
            event.preventDefault();
            showLoader();
            var nbLi = $('.list-news ul li').length,
                indexHidden = $('.list-news ul li').index($('.list-news ul li.hidden'));

            for (var i = indexHidden + 1; i < indexHidden + nblitoshow; i++) {
                $('.list-news ul li:nth-child(' + i + ')').removeClass('hidden');
                if (nbLi <= i) {
                    $('.list-news .show-more').hide();
                }
            }
            hideLoader();
        });
    }


    // Cookboard - SEE MORE handler
    $(document).on('click', '.cookboard .show-more a', function (event) {
        if (!$(this).parent().hasClass('open')) {
            var url = $(this).attr("href");
            $('.show-more', $('.cookboard')).addClass('open');
            $('.show-more .more', $('.cookboard')).hide();
            $('.show-more .less', $('.cookboard')).show();

            if (!$(this).parent().hasClass('loaded')) {
                showLoader();
                $('.show-more', $('.cookboard')).addClass('loaded');
                $.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'html',
                    data: ''
                }).always(function (data) {
                  $('.result-cookboards').append(data);
                  hideLoader();
                });
            }
            $('.result-cookboards').show('300');
        } else {
            $('.result-cookboards').hide('300');
            $('.show-more', $('.cookboard')).removeClass('open');
            $('.show-more .more', $('.cookboard')).show();
            $('.show-more .less', $('.cookboard')).hide();
        }
        event.preventDefault();
    });


    //Commerce Connector
    $('#SelectbusinessRange').change(function (event) {
        /* Act on the event */
        if ($('#SelectbusinessRange').val() != '') {
            var url_address = 'modal-business-selector.php';
            $.ajax({
                type: "GET",
                url: url_address,
                data: "SelectbusinessRange=" + jQuery('#SelectbusinessRange').val() // appears as $_GET['id'] @ ur backend side
            }).done(function (data) {
                    // data is ur summary
                    $('.modal-businessconnector #StoreConnectorAjax').html(data);
            }).always(function (data) {
                    if ($('.modal-businessconnector .commerce-connector .item').length > 1) {
                        $('.modal-businessconnector .commerce-connector').bxSlider({
                            pager: false,
                            infiniteLoop: false,
                            slideWidth: 513,
                            auto: false,
                            hideControlOnEnd: true,
                            onSliderLoad: function () {
                                $('.modal-businessconnector .commerce-connector').parents('.bx-wrapper').addClass('commerce-connector-wrapper')
                            }
                        });
                    }

                    $('#ModalCommerce').find('.modal-body').css({
                        'max-height': '100%'
                    });
            });
        } else {
            //alert('Choose your item');
        }
    });

    $('.recipe-product .show-more a').on('click', function (e) {
        e.preventDefault();
        showLoader();
        $('.recipe-product-list .more').show();
        $('.recipe-product .show-more').hide();
        hideLoader();
    })


    $('a.trigger-content').on('click', function (e) {
        e.preventDefault();
        var link = $(this).attr('href');
        if (!$(this).hasClass('open')) {
            $(link).stop(true, true).show('300');
            $(this).addClass('open')
        } else {
            $(link).stop(true, true).hide('300');
            $(this).removeClass('open')
        }
    })

    function openNav() {
        var mainNav = $('.main-nav'),
            toggleNav = $('.toggle-nav'),
            overlay = $('.overlay');

        if (mainNav.hasClass('show-nav')) {
            if (simpleSlider) {
                simpleSlider.startAuto();
            }

            mainNav.removeClass('show-nav');
            toggleNav.removeClass('active');
            $('.niv2').removeClass('open');
            $('.niv1 .actif').removeClass('actif');
            $('body').removeClass('open-nav');
            $('.main-nav .wrap-nav.mobile .niv3').removeClass('open-niv3');
        } else {
            if (simpleSlider) {
                simpleSlider.stopAuto();
            }
            toggleNav.addClass('active');
            mainNav.addClass('show-nav');
            mainNav.css("display","block")
            $('body').addClass('open-nav');
            sendEvent('burgerMenuClic', {});
            $(".wrap-nav.mobile").find("li:first-of-type a").addClass("open");
            $(".wrap-nav.mobile").find("li:first-of-type .niv2").css('display', 'block');
        }
    }

    // Gestion de la section "Une humeur, des recettes"
    if ($('#nl-form').length) {
        var tooltipLabel = $('.tooltipLabel').html();
        $('.nl-submit').addClass('inactive');
        if (!$('html').hasClass('lt-ie9')) {
            var nlform = new NLForm(document.getElementById('nl-form'));

            setTimeout(function () {
                $('.nl-form div:first-of-type').attr({
                    "data-toggle": "tooltip",
                    "title": tooltipLabel
                });
                $('.nl-field').tooltip({
                    position: {
                        my: "center bottom",
                        at: "center top",
                    }
                }).tooltip("option", "show");
            }, '300');

        }

        $('#nl-form').submit(function (event) {
            event.preventDefault();
            var op1 = $('#select-humeur').val(),
                op2 = $('#select-produit').val(),
                op3 = $('#select-pour').val();
            if (op1 != "" && op2 != "" && op3 != "") {
                showLoader();
                $('.form-humeur').addClass('submited');
                $('.nl-submit-wrap').hide();
                $('.more', '.humeur').show();
                $('.social-share', '.humeur').show();
                $.ajax({
                    url: ACC.recipe.moodsearchurl + '?op1=' + op1 + '&op2=' + op2 + '&op3=' + op3,
                    type: 'GET',
                    dataType: 'html',
                    data: ''
                }).always( function (data) {
                  $('.result-form').append(data);
                  $('html,body').animate({
                    scrollTop: $('.humeur').offset().top - 63
                  }, 500);
                  hideLoader();
                });
            }
        })
    }
    if ($('.addrBookContainer').length) {
        var HigherAddress = 0;
        $('.addrBookContainer .span4').each(function (index) {
            if ($(this).outerHeight() > HigherAddress) {
                HigherAddress = $(this).outerHeight();
            }
        });

        $('.addrBookContainer .span4').css('height', HigherAddress);
    }
    initScrollingStoreList(isMobile);


    /*store locator detail*/
    $(document).on('click','.list-store li', function () {
        infowindow.close();
        $('.shopdetails').slideUp('fast');
        gotoPoint(jQuery(this).index(),jQuery(this).attr("id"));
    });


    $('.back-to-top a').click(function (e) {
        e.preventDefault();
        $('html,body').animate({
            scrollTop: 0
        }, 1000);
    })

    // Au change du select de la liste des accessoires
    $("#faq-sort").change(function () {
        var selectedValue = $(this).val();
        updateURLParameter("sort", selectedValue);
    });

    function updateURLParameter(param, paramVal) {
        var url = window.location.href;
        var newAdditionalURL = "";
        var tempArray = url.split("?");
        var baseURL = tempArray[0];
        var additionalURL = tempArray[1];
        var temp = "";
        if (additionalURL) {
            tempArray = additionalURL.split("&");
            for (i = 0; i < tempArray.length; i++) {
                if (tempArray[i].split('=')[0] != param) {
                    newAdditionalURL += temp + tempArray[i];
                    temp = "&";
                }
            }
        }
        var rows_txt = temp + "" + param + "=" + paramVal;
        window.location = baseURL + "?" + newAdditionalURL + rows_txt;
    }

    $(".emptyCart").click(function (e) {
        e.preventDefault();
        $('.ConfModal').modal();
    });


    $('.dropmenu .dropmenu-toggle').on('click', function (e) {
        e.preventDefault();

    });

    //gestion des menu du header
    $( document ).ready(function() {
        $('.dropmenu .dropmenu-toggle').on('click', function (e) {
            e.preventDefault();
            $('.search').removeClass('active');
            $('.modal-backdrop').remove();
            $('#NoResult').show();
            if ($(this).parent().hasClass('open')) {
                $(this).parent().toggleClass('open');
                $('body').toggleClass('open-search');
            } else {
                if ($('.krups-animate').length) {
                    $.fn.fullpage.setMouseWheelScrolling(true);
                    $.fn.fullpage.setAllowScrolling(true);
                }
                $('.dropmenu.open').removeClass('open');
                $('body.open-search').removeClass('open-search');
                $(this).parent().toggleClass('open');
                $('body').toggleClass('open-search');
                if (!$(e.currentTarget).is('#trigger-search') || !GSEB.constants.autocompleteRich) {
                    $('<div class="modal-backdrop fade in search"></div>').appendTo('body');
                }
                setTimeout(function () {
                    $('.head-entry .search form input#search').focus();
                }, 1000);
            }
        });
    });

    /**
     * JS suggestions popup
     */
    $('.dropmenu .dropmenu-toggle.trigger-search').on('click', function (e) {
    	if ($(this).parent().hasClass('open')) {
    		$('#NoResult').show();
    	}else{
    		$('#NoResult').hide();
    	}
    });


    $(".head-entry .search form input[type=TEXT]").on("change paste keyup", function() {
    	  if($(this).val().length>0){
    		  $('#NoResult').hide();
    	  }else{
    		  $('#NoResult').show();
    	  }
    });

    // gestion du clique à l'exterieur des menus deroulants du header quand ils sont ouvert
    $('body').on('click', function (e) {
      if (!$('.dropmenu').is(e.target) && $('.dropmenu').has(e.target).length === 0 && $('.open').has(e.target).length === 0) {
        if ($('.open').is('form.dropmenu[name="search_form"]')) {
          if ($('.krups-animate').length) {
            $.fn.fullpage.setMouseWheelScrolling(true);
            $.fn.fullpage.setAllowScrolling(true);
          }
        }
        $('.dropmenu').removeClass('open');
      }
    });

    // gestion du clique à l'exterieur des menus deroulants du header quand ils sont ouvert
    $('#trigger-search').on('click', function (event) {
      if (GSEB && GSEB.constants.autocompleteRich && GSEB.allBrands.richAutocomplete) {
        GSEB.allBrands.richAutocomplete.onCloseHandler($.extend({}, event, {
          target: event.target,
          currentTarget: event.target
        }))
      }
    });

    $(document).on('click','.open-search .modal-backdrop',function(){
        $('body').removeClass('open-search');
        $('.modal-backdrop').remove();
        $('#NoResult').hide();
    });

    $(document).on('click','.modal-backdrop',function(){
        if($('.krups-animate').length) {
            $.fn.fullpage.setMouseWheelScrolling(true);
            $.fn.fullpage.setAllowScrolling(true);
        }
    });

    $(document).on('click','.trigger-cart',function(){
        if ($(this).parent().hasClass('open')) {
            if($('.krups-animate').length) {
                $.fn.fullpage.setMouseWheelScrolling(false);
                $.fn.fullpage.setAllowScrolling(false);
            }
        } else {
            if($('.krups-animate').length) {
                $.fn.fullpage.setMouseWheelScrolling(true);
                $.fn.fullpage.setAllowScrolling(true);
            }
        }
    });


    //prevent copy /paste
    $('.noctrlcv').on("cut copy paste", function (e) {
        e.preventDefault();
    });
    $('.noctrlcv').keydown(function (event) {
        if (event.ctrlKey == true && (event.which == '118' || event.which == '86')) {
            event.preventDefault();
        }
    });


    jQuery("#submitFormLoginAjax").click(function (event) {
        var basesecureURL = jQuery("#FormLogin").attr('secure-action');
        jQuery("#messageErrorsLogin").html('');
        event.preventDefault();
        jQuery.ajax({
            type: "post",
            data: jQuery("#FormLogin").serialize(),
            url: basesecureURL + "/login/request/validate"
        }).done(function (data) {
                if (data.success == true) {
                    jQuery("#FormLogin").attr('action',
                        basesecureURL + "/j_spring_security_check");
                    jQuery("#FormLogin").submit();
                } else {
                    jQuery("#messageErrorsLogin").html(data.message);
                }
        }).fail( function () {
                jQuery("#messageErrorsLogin").html(
                    'Votre identifiant ou mot de passe est incorrect.');
        });
    });

    jQuery("#btn-mood").click(function (event) {
        var op1 = $('#select-humeur').val(),
            op2 = $('#select-produit').val(),
            op3 = $('#select-pour').val();
        if (op1 == "" || op2 == "" || op3 == "") {
            var selectModal = '#ModalMoodSearch';
            $(selectModal).show();
            $(selectModal).modal();
        }
    });


    /* Retour a la lighe apres le point*/
    var test = $('.quantity .msg span').text();
    var result = test.replace(/\./g, '.<br/>');

    $('.quantity .msg span').html(result);


    /* Pagination Handler*/
    if ($('.pagination').length) {
        var $pagination = $('.pagination'),
            nbPage = $pagination.find('li').length, // Nombre de pages
            currentPage = $pagination.find('li.active').index(); // index de la page active

        $pagination.find('li').hide();
        for (var i = currentPage - 3; i < currentPage + 3; i++) {
            if (i >= 0 && i <= nbPage) {
                $pagination.find('li').eq(i).show();
            }
        }
        $pagination.find('li:last-child').show();
        $pagination.find('li:first-child').show();
    }


    $(document).on('click', '.CountrySeletorBC', function () {
        $(this).parent().find('.country-selector-bc').show();
    });

    $(document).on('mouseleave', '.country-selector-bc', function () {
        $('.country-selector-bc').hide();
    });

    /* Moulisearch Gestion de l'autoscroll */


    if ($('body').hasClass('page-MouliSearchPage')) {
        var filterMoulisearch = getUrlParameter('q');
        if (filterMoulisearch) {
            //mobile
            if (isMobile == true) {
                scrollToAnchor('#product-list', 49);
            } else {
                scrollToAnchor('.moulisearch .description', 70);
            }
        }
    }


    if (isMobile == true) {
        /**** Find idea page ****/
        /* change search submit text for icon */
        var recipeFinder = $('.page-RecipeHomePage .recipe-finder .container form .submit');
        recipeFinder.attr('value', '');


        /* put wrap-push at very end of new-recipe grid */
        var wrapPush = $('.page-RecipeHomePage .wrap-push');
        wrapPush.detach();
        wrapPush.appendTo($('.page-RecipeHomePage .recipe-layout'));

        /* create carousel on the fly */
        var recipeProductList = $('.page-RecipeHomePage .recipe-product-list');
        recipeProductList.addClass('recipe-slider');
        recipeProductList.find('.more').find('.recipe-product-item').detach().appendTo(recipeProductList);
        recipeProductList.find('.more').detach();
        $(recipeProductList).bxSlider({
            slideWidth: 200,
            pager: false
        });

        /* put big cookboard before small ones */
        var bigCookboard = $('.page-RecipeHomePage .cookboard .big');
        bigCookboard.detach();
        bigCookboard.prependTo('.board');

        /* wrap filters in a div and create slideup/slidedown */
        var ourRecipeFilters = $('.list-recipe .span3 .accordion');
        $('.mobile-accordion-header').next('.accordion').hide();
        $('.mobile-accordion-header').on('touchstart', function () {
            $(this).next('.accordion').slideToggle();
            $(this).toggleClass('active');
        });
        /* put wrap-push at very end of list-recipe grid */
        var wrapPush = $('.list-recipe .span3 .wrap-push');
        //wrapPush.detach();
        wrapPush.appendTo($('.list-recipe .span9'));


        var productListTrigger = $('.list-product .scroll-filters > .filters > .item:first-child');
        var productListitem = $('.list-product .scroll-filters .filters .item:not(:first-child)');
        productListTrigger.addClass('toggle');
        productListitem.addClass('deploy');
        productListitem.hide();
        $(productListTrigger).on('touchstart', function () {
            productListitem.slideToggle();
            productListTrigger.toggleClass('active');
        });

        if ($('.zone-compare').length) {
            $('.row-fluid.bloc-light .zone-compare').remove();
            var zoneCompare = $('.zone-compare');

            zoneCompare.prependTo(".list-product .span9");
            $(window).scroll(function () {
                var offset = zoneCompare.offset();
                var zoneComparePosY = offset.top;
                if ($(this).scrollTop() > zoneComparePosY - 60) {
                    $('.zone-compare').addClass("float");
                } else {
                    $('.zone-compare').removeClass("float");
                }
            });
        }

        $('.content-edito table').each(function () {
            $(this).wrap("<div class='table-container'></div>");
        });

        if ($('.recipe-layout').length) {
            $('.wrap-push').appendTo('.recipe-layout');
        }

        //deplacement des bannières pour le mobile.
        $('.page-search .row-fluid.bloc-head > .yCmsContentSlot .span12, .page-ProductComparatorPage .row-fluid.bloc-head > .span12').addClass('banner-mobile');
        $('.list-cat .span9 > .picture').prependTo('.list-cat > .row-fluid.bloc-light').addClass('banner-mobile');
        $('.store-on-line-intro > div > a > .border').prependTo('.page-StoreFinderOnLinePage .main-content > .row-fluid.bloc-light').addClass('banner-mobile');
        $('.page-CSSRepairersWithMap .span9 > .faq-banner .picture').prependTo('.page-CSSRepairersWithMap .main-content > .row-fluid.bloc-light').addClass('banner-mobile');
        $('.page-faqhomepage .span9 > .faq-banner .picture').prependTo('.page-faqhomepage .main-content > .row-fluid.bloc-light').addClass('banner-mobile');
    }

    $(window).scroll(function () {
        if (isMobile !== true) {
            if ($(this).scrollTop() > 5) {
                if ($('body').is('.moulinex-portal')) {
                } else {
                    $('body').addClass("mini-header");
                }
            } else {
                $('body').removeClass("mini-header");

            }
        }
    });

    /* Description courte detail produit */

    var contentDescription = $('.product-content-short-description'),
        contentDescriptionTxt = $('.product-content-short-description').html(),
        contentDescriptionHeight = $('.product-content-short-description').height(),
        truncateCharactersCountLimit = 230,
        truncateCharactersCountLimitAlt = 130,
        truncateLinesCountLimit = 3,
        courteHeightContentDescription = 75;

    if(isMobile){
        truncateCharactersCountLimit = 210;
        truncateCharactersCountLimitAlt = 210;
        truncateLinesCountLimit = 4;
        courteHeightContentDescription= 100;
    }else if(isTablet){
        truncateCharactersCountLimit = 180;
        truncateCharactersCountLimitAlt = 180;
        truncateLinesCountLimit = 4;
        courteHeightContentDescription= 100;
    }

    contentDescription.each(function () {
        var maxLinesToShow = 3;
        var contentDescription = $(this);
        var contentDescriptionHeight = contentDescription.height();
        var contentDescriptionLineHeight = contentDescription.css('line-height').slice(0, contentDescription.css('line-height').length - 2);
        var linesCount = contentDescriptionHeight / contentDescriptionLineHeight;

        if( linesCount > maxLinesToShow ){
            var showReadMore = false;
            $('.product-content-short-description').css('height', 'auto');
            if (contentDescription.html().length > truncateCharactersCountLimit) {
                var truncated = contentDescription.html().trim().substring(0, truncateCharactersCountLimit).split(' ').slice(0, -1).join(' ') + ' (...)';
                contentDescription.html(truncated);
                $('.product-short-description .read-more').removeClass("hide");
                showReadMore = true;
            }

            if(linesCount >= truncateLinesCountLimit && contentDescription.html().trim().split(' ').slice(0,-1).join().length>truncateCharactersCountLimitAlt){
                var truncated = contentDescription.html().trim().substring(0, truncateCharactersCountLimitAlt).split(' ').slice(0, -1).join(' ') + ' (...)';
                contentDescription.html(truncated);
                $('.product-short-description .read-more').removeClass("hide");
                showReadMore = true;
            }
            $('.product-content-short-description').show();

            if(showReadMore == true)
            $('.read-more').show();

        }

        $('.product-content-short-description').show();



    } );

    // Read more
    $(document).on('click', '.read-more', function (e) {
        e.preventDefault();
        var $descContent = $(this).prev();

        $descContent.css('max-height', '600px');
        $(this).addClass("hide");
    });
    //readMoreContent();

});

//function readMoreContent() {
//	$('.read-more').each(function () {
//    	var $descContent = $(this).prev(),
//    		$minHeight   = 63 ;
//    	console.log($descContent.height())
//    	if ($descContent.innerHeight() > $minHeight ) {
//    	}else {
//    		$(this).addClass("hide");
//    	}
//    	$descContent.css('max-height', '63px');
//    });
//}

function truncateShoretDescription(lines) {
    var contentDescription = $('.product-content-short-description'),
        contentDescriptionTxt = $('.product-content-short-description').html(),
        contentDescriptionHeight = $('.product-content-short-description').height(),
        truncateCharactersCountLimit = 230,
        truncateCharactersCountLimitAlt = 200,
        truncateLinesCountLimit = lines,
        courteHeightContentDescription = 77;

    contentDescription.each(function () {

        var contentDescription = $(this);
        var contentDescriptionHeight = contentDescription.height();
        var contentDescriptionLineHeight = contentDescription.css('line-height').slice(0, contentDescription.css('line-height').length - 2);
        var linesCount = contentDescriptionHeight / contentDescriptionLineHeight;


        $('.product-content-short-description').css('height', 'auto');

        if (contentDescription.html().length > truncateCharactersCountLimit) {
            var truncated = contentDescription.html().trim().substring(0, truncateCharactersCountLimit).split(' ').slice(0, -1).join(' ') + ' (...)';
            contentDescription.html(truncated);
            $('.product-short-description .read-more').removeClass("hide");
        }

        if(linesCount >= truncateLinesCountLimit){
            var truncated = contentDescription.html().trim().substring(0, truncateCharactersCountLimitAlt).split(' ').slice(0, -1).join(' ') + ' (...)';
            contentDescription.html(truncated);
            $('.product-short-description .read-more').removeClass("hide");
        }
        $('.product-content-short-description').show();

    });

}



//Landing page - Masterchef //
if ($('.landing-masterchef')) {
    var simpleSlider = $('.gif-masterchef').bxSlider({
        controls: false,
        mode: 'fade',
        infiniteLoop: true,
        auto: true,
        pause: 9000,
        speed: 1000,
        pager: false,
        easing: 'ease-in-out',
    });
}

//End

function scrollToAnchor(aid, delta) {
    var aTag = $(aid);
    $('html,body').animate({scrollTop: aTag.offset().top - delta}, 'slow');
}


var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};


function toggleniv2(clickNiv1) {
    var sub = clickNiv1.parent().find('.niv2');
    if (clickNiv1.hasClass('actif')) {
        $('.niv2').removeClass('open');
        clickNiv1.removeClass('actif');
        return false;
    }

    $('.niv2 ,.side-menu-level2').removeClass('open');
    $('.niv1 .actif').removeClass('actif');
    clickNiv1.addClass('actif');
    $(sub).toggleClass('open');
}

//Product Detail - Array product comparision
function scrollableTable() {
    var nbvisible = parseInt(jQuery('.scrollableTable').attr('data-visible'));

    jQuery('.scrollableTable').hide();
    jQuery('.scrollable-control[data-slide="prev"]').addClass('disabled');
    jQuery('.scrollableTable th:not(.info), .scrollableTable td:not(.info), .scrollableTable:not(.nohover) td').each(function () {
        jQuery(this).hide();
        jQuery(this).hover(function () {
            jQuery(this).toggleClass('on');
            var colnum = jQuery(this).parent('tr').children('.on').index();
            if (colnum > 0) {
                jQuery('.scrollableTable tr').each(function () {
                    jQuery(this).children(':eq(' + colnum + ')').addClass('on');
                });
            } else {
                jQuery('.on').removeClass('on');
            }
        });
    });
    jQuery('.scrollableTable .info').show();

    for (var i = 1; i <= nbvisible; i++) {
        jQuery('.scrollableTable tr').each(function () {
            jQuery(this).children('th:eq(' + i + '), td:eq(' + i + ')').show().addClass('active');
        });
    }

    jQuery('.scrollable-control').on('click', function () {
        var button = this;
        jQuery(button).hide();
        jQuery('.scrollableTable tr').each(function () {
            var thisLine = this;
            if (jQuery(button).attr('data-slide') == 'next') {
                if (jQuery(this).children('th.active:not(.info), td.active:not(.info)').last().next().length > 0) {
                    jQuery('.scrollable-control[data-slide="prev"]').removeClass('disabled');
                    var nextObj = jQuery(this).children('th.active:not(.info), td.active:not(.info)').last().next();
                    jQuery(this).children('th.active:not(.info), td.active:not(.info)').first().hide('slide', {direction: "left"}, 'fast', function () {
                        nextObj.show('slide', {direction: "right"}, 'fast').addClass('active');
                        jQuery(button).show(function () {
                            if (jQuery(thisLine).children('.active:not(.info)').last().next().length == 0) {
                                jQuery(button).addClass('disabled');
                            }
                        });
                    }).removeClass('active');
                } else {
                    jQuery(button).addClass('disabled');
                    jQuery(button).show();
                }
            } else {
                if (jQuery(this).children('th.active:not(.info), td.active:not(.info)').first().prevUntil('.info').length > 0) {
                    jQuery('.scrollable-control[data-slide="next"]').removeClass('disabled');
                    var prevObj = jQuery(this).children('th.active:not(.info), td.active:not(.info)').first().prev();
                    jQuery(this).children('th.active:not(.info), td.active:not(.info)').last().hide('slide', {direction: "right"}, 'fast', function () {
                        prevObj.show('slide', {direction: "left"}, 'fast').addClass('active');
                        jQuery(button).show(function () {
                            if (jQuery(thisLine).children('.active:not(.info)').first().prev(':not(.info)').length == 0) {
                                jQuery(button).addClass('disabled');
                            }
                        });
                    }).removeClass('active');
                } else {
                    jQuery(button).addClass('disabled');
                    jQuery(button).show();
                }
            }
        });
    });
    if (jQuery('.scrollableTable table tbody tr:first-child td:not(.info,.reference)').length < nbvisible) {
        jQuery('.scrollableTable .scrollable-control').hide();
    }
    jQuery('.scrollableTable').show();


    /* Cookie Handler*/
    if ($('.cookie').length) {
        if ($.cookie("bannerCookie") !== "closed") {
            setTimeout(function () {
                $('.cookie').addClass('show');
            }, 1500);
        } else {
            $('.cookie').remove();
        }
        $('.cookie .close, .cookie .ok').on('click', function () {
            $('.cookie').removeClass('show');
            setTimeout(function () {
                $('.cookie').remove();
            }, 1500);
            $.cookie("bannerCookie", "closed", {expires: 356});
        })
    }

    if ($('.oldBrowsers').length) {
        if ($.cookie("oldBrowsers") !== "closed") {
            $('.oldBrowsers').show();
        } else {
            $('.oldBrowsers').remove();
        }
        $('.oldBrowsers .close').on('click', function () {
            $('.oldBrowsers').remove();
            $.cookie("oldBrowsers", "closed", {expires: 356});
        })
    }

}

function refresh_compare() {
    if ($(".gocompare").length < 2) {
        $(".gocompare").hide();
        $('.zone-compare .btn').hide();
    }
}

var CarouselUtils = (function () {

    return {
        getCurrentBreakPoint: function (breakPoints) {
            breakPoints = breakPoints || [1300, 1200, 1023, 768];
            var width =  $(window).width();
            for (var index in breakPoints) {
                if (width >= breakPoints[index]) return breakPoints[index];
            }
            return 0;
        },
        getCarouseResponsiveOptionForBreakPoints: function (sliderOptionsResponsive, breakpoint) {
            return (sliderOptionsResponsive[breakpoint || CarouselUtils.getCurrentBreakPoint()] || {
                items: 0
            });
        },
        initinitializeOwlCarousel: function ($carousel, itemSelector, sliderOptionsResponsive, breakPoints) {
            var selector = itemSelector || 'li.thumbnail';
            var currentBreakpoint = CarouselUtils.getCurrentBreakPoint(breakPoints);
            var itemsPerPage = CarouselUtils.getCarouseResponsiveOptionForBreakPoints(sliderOptionsResponsive, currentBreakpoint).items;
            var numberOfItems = $carousel.find(selector).length;
            var itemsNeeded = itemsPerPage - (numberOfItems % itemsPerPage);

            if (!!itemsNeeded) {
                while (numberOfItems % itemsPerPage > 0 && itemsNeeded > 0) {
                    var placeholder = $carousel.find(selector + ":first-child").clone().addClass("on-init-cloned-item").css("visibility", "hidden");
                    $carousel.append(placeholder);
                    itemsNeeded--;
                }

                $carousel.on('initialized.owl.carousel', function (event) {
                    $(this).find('.on-init-cloned-item').parent().css("visibility", "hidden");
                })
            }
        }
    }
})();

function initProductViewer() {
    var carouselMinishow = $(".minishow");
    var sliderOptions = {
        items: 7,
        slideBy: 7,
        loop: true,
        lazyLoad: true,
        nav: true,
      //  navRewind: false,
        pagination: false,
        dots: false,
        rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false,
        mouseDrag: false,
        //responsiveRefreshRate: 100,
        responsive : {
            1023 : {
                items: 5,
                slideBy: 5
            },
            1200 : {
                items: 6,
                slideBy: 6,
            },
            1300 : {
                items: 7,
                slideBy: 7,
            }
        }
    };

    carouselMinishow.on("initialize.owl.carousel", function(event) {
        CarouselUtils.initinitializeOwlCarousel(carouselMinishow, 'li.thumbnail', sliderOptions.responsive, [1300, 1200, 1023])
    });

    carouselMinishow.owlCarousel(sliderOptions);
    activeProductViewer({
        offset: CarouselUtils.getCarouseResponsiveOptionForBreakPoints(sliderOptions.responsive).items
    });
    $('#CarouselDetailProductBig.carousel').on('slid', function (e) {
        $('.minishow .owl-item').removeClass('active-viewer');
        activeProductViewer({ offset: CarouselUtils.getCarouseResponsiveOptionForBreakPoints(sliderOptions.responsive).items });
    });
}

function activeProductViewer(options) {
    $('#CarouselDetailProductBig .carousel-inner .item').each(function () {
        if ($(this).hasClass('active')) {
            // console.log('activeProductViewer', $(this).index(), $(this).index() + (!!options && !!options.offset ? options.offset : 0), this);
            $('.minishow .owl-item').eq($(this).index() + (!!options && !!options.offset ? options.offset : 0)).addClass('active-viewer');
        }
    });
}



// comportement go compare
function initGoCompare(maxCheckError, minCheckError) {

    jQuery('.gocompare').each(function () {
        if ((jQuery(this).children('input').is(':checked')) && (jQuery('.gocompare input[type=checkbox]:checked').length > 1)) {
            jQuery('.zone-compare').removeClass('inactiv');
        } else {
            jQuery('.zone-compare').addClass('inactiv');
        }
        jQuery(this).children('a.yes').click(function () {
            window.location = jQuery(this).attr('data-compare');
            return false;
        });
    });

    jQuery('.gocompare input[type=checkbox]').click(function (e) {
        var maxItemsDesktop = 4;
        var maxItemsMobile = 2;
        if ($(document).width() < 768) {
            isMobile = true;
        } else {
            isMobile = false;
        }
        if ((!isMobile && countGoCompare() <= maxItemsDesktop )||(isMobile && countGoCompare() <= maxItemsMobile)) {
            playGoCompare(jQuery(this));
        } else {
            if(isMobile){
                maxCheckError = maxCheckError.replace(maxItemsDesktop,maxItemsMobile);
            }
            $("#ModalMessage .modal-body").html(
                '<p>' + maxCheckError + '</p>');
            $("#ModalMessage").show();
            $("#ModalMessage").modal();
            $("#ModalMessage").on('hidden.bs.modal', function () {
                $("#ModalMessage .modal-body").html("");
                $("#ModalMessage").removeClass("modal-business");
            });
            return false;
        }
        //   $(".gocompare input[type=checkbox]").trigger( "check" );


    });
}

function notification(msg, type) {
    $('#globalMessages').empty().append("<div class='information_message " + type + "'><span class='single'></span><p>" + msg + "</p></div>");
    $('html,body').animate({
        scrollTop: $('#globalMessages').offset().top - 63
    }, 500);
    return false;
}

function killNotification() {
    $('#globalMessages').empty();
}

function countGoCompare() {
    return jQuery('.gocompare input[type=checkbox]:checked').length;
}

function playGoCompare(checkbox) {
    var minItemsToCompare = 2;
    var firstItem = 1;

    if (checkbox.is(':checked')) {
        if(countGoCompare() >= minItemsToCompare || countGoCompare() == firstItem ) {
            //activate checkbox style
            checkbox.parent().removeClass('checkOff').addClass('checkOn');
            //add border on selected element
            checkbox.parents('.product-item').addClass("active");

            if(countGoCompare() > firstItem){
                // add compare button
                checkbox.parent('label').addClass('active');
                //activate previous selected elements
            }

            if (isMobile) {
                $('.gocompareBtn').show('fast');
            }

        }

    }
    else {
        checkbox.parent('label').removeClass('active');
        checkbox.parent().removeClass('checkOn').addClass('checkOff');
        checkbox.parents('.product-item').removeClass("active");

    }

    //UpdateAllCompareElements
    $('.list-content').find('.product-item .gocompare input[type=checkbox]:checked').each(function(){
        if(!$(this).parent('label').hasClass('active') && countGoCompare() > firstItem) {
            $(this).parent('label').addClass('active');
        }
        else if (countGoCompare() == firstItem) {
            $(this).parent('label').removeClass('active');
        }


    })
}



/* Autocomplete Highlight function */
function HighlightAutocomplete() {
    $.ui.autocomplete.prototype._renderItem = function (ul, item) {
        var re = new RegExp("^" + this.term, "i");
        var t = item.label.replace(re, "<span style='font-weight:bold;'>" + this.term + "</span>");
        return $("<li></li>")
            .data("item.autocomplete", item)
            .append("<a>" + t + "</a>")
            .appendTo(ul);
    };
}


/* Only on IE 8 */
function IE() {
    $('.mymoulinex-slider .item').each(function (index) {
        $(this).addClass('nth-child-' + parseInt(index + 1))
    })
}

/* Loader Handler */
function hideLoader() {
    $('.loader').fadeOut("fast", function () {
        $('.loader').css('display', 'none');
    });
}

function showLoader() {
    $('.loader').css('display', 'block').fadeIn("slow");
}


function nlReset() {
    showLoader();

    $('.nl-submit').addClass('inactive');
    $('.nl-submit-wrap').show();
    $('.more', $('.humeur')).hide();
    $('.social-share', $('.humeur')).hide();
    $('.result-form').empty();
    hideLoader();
    $('html,body').animate({
        scrollTop: $('.humeur').offset().top - 63
    }, 500);
    $('.nl-field-toggle').each(function () {
        $(this).html('&nbsp;');
    })

    $('select', $('.nl-form')).each(function () {
        $(this).prop('selectedIndex', 0);
    })
}


function incrementQuantity(form, update) {
    var obj = jQuery(form).find('#quantity');
    var qty = parseInt(obj.val());

    obj.val(qty + 1);
    if (update == true) {
        jQuery(form).submit();
    }
}

function decrementQuantity(form, update) {
    var obj = jQuery(form).find('#quantity');
    var qty = parseInt(obj.val());

    if (qty > 1) {
        obj.val(qty - 1);
        if (update == true) {
            jQuery(form).submit();
        }
    }
}

function incrementQuantityForAcc(form, max, update) {
    var obj = jQuery(form).find('#qty');
    var qty = parseInt(obj.val());

    if (qty < max) {
        obj.val(qty + 1);
        if (update == true) {
            jQuery(form).submit();
        }
    } else {
        jQuery(form).find('#msg_error').show();
    }
}

function decrementQuantityForAcc(form, update) {
    var obj = jQuery(form).find('#qty');
    var qty = parseInt(obj.val());
    jQuery(form).find('#msg_error').hide();

    if (qty > 1) {
        obj.val(qty - 1);
        if (update == true) {
            jQuery(form).submit();
        }
    }
}

function confirmDeleteEntry(msg) {
    if (confirm(msg)) {
        return true;
    } else {
        return false;
    }
}

function handleMoulisearchLoad() {
    $(document).on('click', '.wrap-product-list .show-more a', function (event) {
        $('.show-more').hide();
        //$('.show-more', $('.wrap-product-list')).hide();
        event.preventDefault();
        var url = $(this).attr("href");
        showLoader();
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'html',
            data: ''
        }).always(function (data) {
          $('.product-list').append(data);
          //handleMoulisearchLoad();
          hideLoader();
        });
    });
}

/* funciton TEFAL */

function LoadMore(obj) {
    jQuery(obj).parents('.see-more').hide();
    var urlLoc=jQuery(obj).attr('seo-data-url');
    if(!(typeof urlLoc !== typeof undefined && urlLoc !== false)){
        urlLoc=jQuery(obj).attr('href');
    }

    jQuery.ajax({
        url: urlLoc
    }).done(function (html) {
        //var link_parents = jQuery(obj).parents(".range");
        jQuery(obj).parents(".list-content").find(".item").remove();
        jQuery(obj).parents(".list-content").html(html);
        initGoCompare();
        refresh_compare();
        // jQuery( this ).addClass( "done" );
        //Analytic.bindAddToComparatorEvent(jQuery(obj).parents(".list-content"));
    });

}

/* ajax for load more results for search single and multiple */
function LoadMoreResults(obj, seeAll, idName) {
    seeAll = typeof seeAll !== 'undefined' ? seeAll : false;

    jQuery(obj).parents('.see-more').remove();
    var id = '#' + idName;
    if (seeAll == true) {
        var urlLoc=jQuery(obj).attr('seo-data-url');
        if(!(typeof urlLoc !== typeof undefined && urlLoc !== false)){
            urlLoc=jQuery(obj).attr('href');
        }
        jQuery.ajax({
            url: urlLoc
        }).done(function (html) {
            $(id).html(html).slideDown('slow', 'linear');
            truncateShoretDescription(3);
        });

    } else {
        jQuery.ajax({
            url: jQuery(obj).attr('href')
        }).done(function (html) {
            $(id).html($(id).html() + html).slideDown('slow', 'linear');
            truncateShoretDescription(3);
        });
    }
}


$('.product-comparator .close').on('click', function () {
    var i = 0;
    $('.scrollableTable tr th').each(function () {
        i++;
    });
    if (i > 3) {
        var colnum = $(this).parent().parent().index();
        if (colnum > 0) {
            $('.scrollableTable tr').each(function () {
                $(this).children(':eq(' + colnum + ')').remove();
            });
            var w_table = $('#ScrollabeTableCompare').width();
            //w_table = eval(w_table) - 165;
            //w_table = $('#ScrollabeTableCompare').css('width',w_table);
            // $('#ScrollabeTableCompare td, #ScrollabeTableCompare th').css('width', 240);
        }
        if (i == 4) {
            $('.scrollableTable .close').fadeOut();
        }
    }
});

function hideClassificationInrRowFilterMode() {
  $('.product-comparator #ScrollabeTableCompare tr.comparison').each(function(){
    var first = $(this);
    var next = first.next();
    var count = 0;
    while(next.length>0 && !next.hasClass("comparison")) {
      if(!next.hasClass("ressemblant")) {
        count++;
      }
      next = next.next();
    }
    if(count === 0) {
      first.hide();
    }
  });
}

$('.product-comparator .facet_block-label input').on('change', function () {
    var is_checked = $(".product-comparator .facet_block-label input:checked").length;
    if (is_checked == 0) {
        $('.product-comparator #ScrollabeTableCompare tr').show();
    }
    else {
        $('.product-comparator #ScrollabeTableCompare tr.ressemblant').hide();
        hideClassificationInrRowFilterMode();
    }
});

function bindForm() {
    $('#new_address_form').on('change', function () {
        var url_address = $("#add-address-button").attr("data-ajax");
        var isoCode = $('#new_address_form').val();
        jQuery.ajax({

            type: "GET",
            url: url_address,
            data: {country: isoCode}
            //data: "id=" + id, // appears as $_GET['id'] @ ur backend side
        }).done(function (data) {
                // data is ur summary
                $('#AddressManager').html(data.validatedForm);
                bindForm();
        }).always(function (data) {
                jQuery('#AddressManager').slideDown();

        });
    });
}

// BRA -1273 : upgrade companion
function validateCompatibiliteCompanion()
{
    $(".compatibilite-comp-par2").show();
    $(".validate-compatibilite-comp-btn").first().hide();
    initializeDatePicker();
}
function closeModalMessage(idModalMessage)
{
    $('#'+idModalMessage).modal('hide');
}

function validateCompatibiliteCompanionForm(event)
{
    hasError=false;

    if ($('#dateCollecte').val() != '')
    {
        $("#upgrade-comp-date-collecte-required").hide();
    }
    else
    {
        $("#upgrade-comp-date-collecte-required").show();
        hasError =true;
    }


    if ($('#dateRetour').val() != '')
    {
        $("#upgrade-comp-date-retour-required").hide();
    }
    else
    {
        $("#upgrade-comp-date-retour-required").show();
        hasError =true;
    }

    if ($('#mobile').val() != '')
    {
        $("#upgrade-comp-mobile-required").hide();

        if (document.getElementById('mobile').validity.valid) {
            $("#upgrade-comp-mobile-invalide").hide();
        }
        else
        {
            hasError =true;
            $("#upgrade-comp-mobile-invalide").show();
        }
    }
    else
    {
        $("#upgrade-comp-mobile-invalide").hide();
        $("#upgrade-comp-mobile-required").show();
        hasError =true;
    }

    if(!hasError)
    {
        $.ajax({
            type: $("#upgradeCompanionForm").attr('method'),
            data: $("#upgradeCompanionForm").serialize(),
            url:  $("#upgradeCompanionForm").attr('action')
        }).done(function (data)
            {
                //si la validation des dates + mobile est effectue avec succes il faut ajouter le produit au panier
                closeModalMessage('ModalMessage');
                if(data==true) // ce test est ajoute pour verifeir que entre temps aucun produit n'est ajoute au panier
                {
                    $.ajax({
                        type: $(".companion-add-to-cart-form").attr('method'),
                        data: $(".companion-add-to-cart-form").serialize(),
                        url:  $(".companion-add-to-cart-form").attr('action')
                    }).done( ACC.product.displayAddToCartPopup
                    ).fail(function(cartResult, statusText, xhr, formElement) {
                            console.error("Error with add to cart response :"+ statusText);
                    });
                }
                else
                {
                    console.error("produit n'est pas cumulable");
                }
            }).fail(function () {
                console.error("Error upgradeCompanionForm ");
        });

    }
}

function gsebAddressManager(obj) {
    $('#AddressManager').slideUp('fast', function () {
        var url_address = $(obj).attr('data-ajax');
        $.ajax({
            type: "GET",
            url: url_address,
            //data: "id=" + id, // appears as $_GET['id'] @ ur backend side
        }).done(function (data) {
                try {
                    data = JSON.parse(data)
                } catch (e) {
                    //Temporary FIX for malformed JSON with escape single quotes
                    data = data.replace(/\\'/g, "'");
                    try {
                        data = JSON.parse(data);

                    } catch (e) {
                        //console.log("Parse JSON ERROR");
                    }
                }

                $('#AddressManager').html(data.validatedForm);
                bindForm();
                bindCreateUpdateAddress();
        }).always(function (data) {
                $('#AddressManager').show();
                scrollToParam('#AddressManager');

        });
    });
}

function bindCreateUpdateAddress() {
    $('.create_update_address_form').on('submit',function (event) {
        event.preventDefault();
        $.ajax({
            url: ACC.config.contextPath + $(this).prop('action'),
            data: $(this).serialize() + '&' + $(this).find("button[type=submit]").prop('name'),
            method: $(this).prop('method')
        }).done(function (data) {
                try {
                    data = JSON.parse(data)
                } catch (e) {
                    //Temporary FIX for malformed JSON with escape single quotes
                    data = data.replace(/\\'/g, "'");
                    try {
                        data = JSON.parse(data);

                    } catch (e) {
                        console.log("Parss JSON ERROR");
                    }
                }

                $(".addrFormContainer").html(data.validatedForm);
                $("#globalMessages").html(data.message);
                bindCreateUpdateAddress();
                if (data.success == 'true') {
                	var addEditText=$(".addressAddEditTxt").clone();
                    $(".addrBookContainer").html(data.addrBook);
                    $(".addrBookContainer").prepend($(addEditText));
                    closeGsebAddressManager();
                }
                $(".template-pages-NewsLetterPageTemplate.page-newsletter .form-horizontal .row-fluid .control-group select,#FormUserIds select,#AddAddressForm select,.display-filters-faq select").wrap("<div class='sort'></div>");
        }).fail(function (xht, textStatus, ex) {
                //console.log("Oops ! Une erreur s'est produite.");
        });
    });
}

function scrollToParam(param) {
    var place = parseInt($(param).offset().top);
    $('html,body').animate({
        scrollTop: place - 63 // -63 pour prendre en compte le header fixe
    }, 600);
}

function closeGsebAddressManager() {
    scrollToParam('body');
    $('#AddressManager').html("");
    appendDeliveryAddress();
    appednAddrBookContainer();
}


function closeAddressManager() {
    $('#AddressManager').slideUp();
}


function confirmDelete(obj, msg) {
    if (confirm(msg)) {
        //alert('you accept : reload the page.');
        return true;
    } else {
        return false;
        //alert('you refuse. do nothing. delete this message.');
    }
}


$("#FormNewsLetter").submit(function (event) {
    event.preventDefault();
});


function verifyTermsAndPaymentChecked()
{
    $(".skip[id^=error]").hide();
    var termsNotChecked = !jQuery('#rules').is(':checked');
    var paymentNotChecked = !jQuery('input[id^=payment-mode-]').is(':checked');
    var stopProcessing = false;
    if (termsNotChecked) {
        jQuery('#errorTOS').show();
        stopProcessing = true;
    }
    else {
        jQuery('#errorTOS').hide();
    }

    if (isSampleOrder===false && paymentNotChecked) {
        jQuery('#errorPM').show();
        stopProcessing = true;
    }
    else {
        jQuery('#errorPM').hide();
    }

    if ($('#detachedPieceCG').length > 0 && !$('#detachedPieceCG').is(':checked')) {
        $('#errorCG-PD').show();
        stopProcessing = true;
    }
    else {
        $('#errorCG-PD').hide();
    }

    if ($('#repareServiceCG').length > 0 && !$('#repareServiceCG').is(':checked')) {
        $('#errorCG-RS').show();
        stopProcessing = true;
    } else {
        $('#errorCG-RS').hide();
    }
    if(!validateLegalTax()){
    	stopProcessing=true;
    }
    if(!validateMobilePhone()){
        stopProcessing=true;
    }

    return !stopProcessing;
}
function showNewsLetterModalIncheckoutPage() {
    $(".skip[id^=error]").hide();
    if(verifyTermsAndPaymentChecked()){

        $('#ModalNewsLetter').modal();
    }

}

//Show Paylib message
$("#FormPaymentMode input[type=radio][id*=payment-mode-]").click( function(){
    if( $("#FormPaymentMode input[type=radio][id*=payment-mode-][value*=paylib]").is(':checked') )
        $("#paylibMessage").show();
    else
        $("#paylibMessage").hide();
});

function validateNLpopin()
{

    if ($('#conditionNL').is(':checked'))
    {
        $('#NewsLetter').submit();
    }
    else
    {
        $('#conditionNLerror').show();
    }

}

function submitNewsletter(){
	$.ajax({
        type: $("#FormNewsLetter").attr('method'),
        data: $("#FormNewsLetter").serialize(),
        url: $("#FormNewsLetter").attr('action')
    }).done(function (data) {
			if(data == "ok") {
				$("#popinMessages").append("<div class='information_message positive'> <span class='single'></span> <span> "+newsLEtterSubscribeEmail+"</span> </div>");
				$("#FormNewsLetter .item-form-news").remove();
				$("#DoubleOptinButton").remove();
				$("#DoubleOptinButtonClose").show("#DoubleOptinButton");
			}else {
				$("#DoubleOptinButtonClose").click();
			}
    }).fail(function () {
			$('#errorSubscription').show();
    });
    $("#FormNewsLetter").submit();
}


function validateTOSForDoubleOptin(url) {
    $(".skip[id^=error]").hide();
	if(verifyTermsAndPaymentChecked()){
		if(isSampleOrder===true){
        	placeSmapleOrder();
        }else{
        	validateTOSAjaxService(url);
        }
        $('#ModalNewsLetter').find('.close').trigger("click");
    }
}

function validateTOS(url) {
    /* if ($('#rules').is(':checked') && ( $('#detachedPieceCG').length <= 0 || $('#detachedPieceCG').is(':checked'))) {
     /*il faut d'abord verifier si la case a cocher existe avant de verifier s'il est coche
     * parce que cette case a cocher n'apparait sauf si il y'a un produit de type X
     */
    $(".skip[id^=error]").hide();
    if(verifyTermsAndPaymentChecked()) {
        jQuery.ajax({
            type: "GET",
            // data : jQuery("#FormNewsLetter").serialize(),
            url: ACC.config.contextPath + "/checkout/multi/verify-currency"
        }).done(function (data) {
                if (data) {
                    if(verifyTermsAndPaymentChecked()){
                        //update news letter data
                        $.ajax({
                            type: $("#FormNewsLetter").attr('method'),
                            data: $("#FormNewsLetter").serialize(),
                            url: $("#FormNewsLetter").attr('action')
                        });
                        $("#FormNewsLetter").submit();
                        if(isSampleOrder===true){
                        	placeSmapleOrder();
                        }else{
                        //go create the order
                        validateTOSAjaxService(url);
                        }
                        /* {
                         *  else {
                         if (!$('#rules').is(':checked')) {
                         $('#errorTOS').show();
                         }
                         else {
                         $('#errorTOS').hide();
                         }
                         if ($('#detachedPieceCG').length > 0 && !$('#detachedPieceCG').is(':checked')) {
                         $('#errorCG-PD').show();
                         }
                         else {
                         $('#errorCG-PD').hide();
                         }

                         $.ajax({
                         type: "post",
                         data: $("#FormPaymentMode").serialize(),
                         url: url,
                         success: function (data) {
                         $('#errorPM').hide();
                         },
                         error: function () {

                         $('#errorPM').show();
                         }
                         });

                         } */

                        $('#ModalNewsLetter').find('.close').trigger("click");

                    }

                } else {
                    jQuery('#errorCurrency').show();
                    $("#currencyModal").show();
                    $("#currencyModal").modal();

                }
        });
    }



}

function validateFormDetachedPiece() {
    if ($('#accessoryCode').val() != '') {
        $.ajax({
            type: $("#detachedPieceForm").attr('method'),
            data: $("#detachedPieceForm").serialize(),
            url: $("#detachedPieceForm").attr('action')
            // valider le formulaire
        }).done(function (data) {	//si l'action cotï¿½ serveur se termine corrï¿½ctement

                /*
                 * si le code categorisation different de "S" : Le client est redirige vers la page detail produit de la piece de rechange.
                 *	La page detail de la piece de rechange est identique a la page d'affichage d'un accessoire.
                 */
                if (data != null && data != '') {
                    if (data.accessoryCategorisation != 'S') {
                        window.location.href = ACC.config.contextPath + data.url;
                    }
                    else {
                        $('#errorNofound').hide();
                        $('#errorNotForSale').show();

                        $('#modalErrorDetachedPiece').modal();
                        Modal.show();

                    }
                }
                else {
                    $('#errorNotForSale').hide();
                    $('#errorNofound').show();

                    $('#modalErrorDetachedPiece').modal();
                    Modal.show();
                }
        }).fail(function () {

                $('#errorNotForSale').hide();
                $('#errorNofound').show();

                $('#modalErrorDetachedPiece').modal();
                Modal.show();
        });

    }
    else {
        $('#errorNotForSale').hide();
        $('#errorNofound').hide();
        $('#errorRequired').show();
    }
}

// fonction ajoute pour handler le click sur le bouton entrer dans le formulaire de recherche des pieces detache
$("#detachedPieceForm").submit(function (event) {
    validateFormDetachedPiece();
    event.preventDefault();
});



function validateFormExplodedView() {
    if ($('#codeSav').val() != '') {
        if (document.getElementById('codeSav').validity.valid) {
            $('#errorInvalid').hide();
            $.ajax({
                type: $("#explodedViewsForm").attr('method'),
                data: $("#explodedViewsForm").serialize(),
                url: $("#explodedViewsForm").attr('action')
                // valider le formulaire
            }).done(function (data) {	//si l'action cote serveur se termine correctement

                    //si la fonction return le code du Media exploded view on redeige vers la fonction qui va afficher la page de la vue eclate
                    if (data != null && data != '') {
                        //exploded-view/codeProduct/detail-exp-view/codeSAv
                        window.location.href = ACC.config.contextPath + "/exploded-view/" + $('#productCodePost').val() + "/detail-exp-view/" + data;
                    }
                    else {
                        $('#errorRequired').hide();
                        $('#errorNofound').show();
                    }
            }).fail(function () {
                    $('#errorRequired').hide();
                    $('#errorNofound').show();
            });
        } else {
            $('#errorRequired').hide();
            $('#errorInvalid').show();
        }
    }
    else {
        $('#errorNofound').hide();
        $('#errorInvalid').hide();
        $('#errorRequired').show();
    }
}
$("#explodedViewsForm").submit(function (event) {
    validateFormExplodedView();
    event.preventDefault();
});

function initScrollingStoreList(isMobile) {
    //scroll store list
    //
    var heightScoll = prestationFilterEnabled == 'true' && $('.page-CSSRepairers').length? 389 : 315;
    if (isMobile == true) {
        heightScoll = 200
    }
    $('.scroll-store').slimScroll({
        height: heightScoll,//$('.actions').height(),
        alwaysVisible: true,
        allowPageScroll: false,
        position: 'right',
        color: '#bebec2',
        opacity: 1,
        distance: 0,
        railVisible: true,
        wheelStep: 6,
        railColor: '#ededee',
        railOpacity: 1
    });
}




function initScrollingStoreListPopin() {
    //scroll store list
    console.log(" -->2");
    jQuery('.scroll-store').slimScroll({
        height: 360,
        alwaysVisible: true,
        allowPageScroll: false,
        position: 'right',
        color: '#888',
        distance: 0,
        railVisible: false,
        wheelStep: 10
    });
}

function gotoPoint(myPoint, posName) {
    google.maps.event.addListenerOnce(map, 'center_changed', function(event) {
        //set a minimum zoom
        // if you got only 1 marker or all markers are on the same spot
        if (this.getZoom() > 13) {
            this.setZoom(13);
        }
    });
    map.setCenter(new google.maps.LatLng(locations[myPoint][2], locations[myPoint][3]));
    setTimeout(function () {
        markerCollection[myPoint].setAnimation(null);
    }, '5000');
    //infowindow.close();
    for (j = 0; j < locations.length; j++) {
        markerCollection[j].setAnimation(null);
    }
    if (markerCollection[myPoint].getAnimation() != null) {
        markerCollection[myPoint].setAnimation(null);
    } else {
        markerCollection[myPoint].setAnimation(google.maps.Animation.BOUNCE);
    }
    showDetails(posName, myPoint);
}

function redimensionnerStore(selecteur) {

    var hauteur = 0;

    $(selecteur).each(function () {
        if ($(this).height() > hauteur) hauteur = $(this).height();
    });
    $(selecteur).each(function () {
        $(this).height(hauteur);
        $(this).addClass("item-redimensionner");
    });

}

// CreateReCaptcha IOS scroll

function createReCaptcha(reCaptchaPubKey, id) {
    Recaptcha.create(reCaptchaPubKey, id, {
        theme: "clean"
    });
}

var HEADER_HEIGHT = 0; // Height of header/menu fixed if exists
var isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
var grecaptchaPosition;

var isScrolledIntoView = function (elem) {
  var elemRect = elem.getBoundingClientRect();
  var isVisible = (elemRect.top - HEADER_HEIGHT >= 0 && elemRect.bottom <= window.innerHeight);

  return isVisible;
};

if (isIOS) {
  var recaptchaElements = document.querySelectorAll('.g-recaptcha');

  window.addEventListener('scroll', function () {
    Array.prototype.forEach.call(recaptchaElements, function (element) {
      if (isScrolledIntoView(element)) {
        grecaptchaPosition = document.documentElement.scrollTop || document.body.scrollTop;
      }
    });
  }, false);
}

var onReCaptchaSuccess = function () {
  if (isIOS && grecaptchaPosition !== undefined) {
    window.scrollTo(0, grecaptchaPosition);
  }
};

//if Add2Any div exist on page , load js
if ($(".a2a_dd")) {
    var a2a_config = a2a_config || {};
    a2a_config.onclick = 1;
    a2a_config.prioritize = ["facebook", "twitter", "linkedin",
        "google_plus", "pinterest", "tumblr", "myspace", "email",
        "google_bookmarks", "yahoo_bookmarks"];
    a2a_config.num_services = 10;
    a2a_config.color_main = "D7E5ED";
    a2a_config.color_border = "D7E5ED";
    a2a_config.color_link_text = "373332";
    a2a_config.color_link_text_hover = "373332";

    (function (d, t) {
        var g = d.createElement(t), s = d.getElementsByTagName(t)[0];
        g.src = '//static.addtoany.com/menu/page.js';
        //s.parentNode.insertBefore(g, s);

    }(document, 'script'));


    //a2apage_dropdown
}


function submitFormUser(obj) {
    var validForm = jQuery(obj).validationEngine('validate');
    if (validForm == true) {
        jQuery(obj).submit();
        StoreLocator
    } else {
        jQuery(obj).validationEngine({
            scroll: false
        });
    }
    return false;
}


/*ajax for load more results store locator*/
function PaginationStore(obj) {
    //TO SIMULATE LOADING -- TO REMOVE WHEN AJAX IS READY
    //jQuery('.zone-showmore').last().after(jQuery('.zone-showmore').clone().hide());
    //jQuery('#StoreLocator').hide();
    jQuery.ajax({url: jQuery(obj).attr('href')}).done(function (html) {
        jQuery('#StoreLocatorZone').html(html).slideDown('slow', 'linear');
        initScrollingStoreList();

        //jQuery( this ).addClass( "done" );
    });
}

function submitAlertEmailCreation(url) {
    var validForm = jQuery("#FormStockAlert").validationEngine('validate');

    if (validForm == true) {
        jQuery.ajax({
            type: "POST",
            data: jQuery("#FormStockAlert").find(
                "input[type='hidden'], :input:not(:hidden)").serialize(),
            url: url
        }).done(function (data) {
                jQuery("#FormStockAlert").find("#globalMessages").html(data);
                if (jQuery("#FormStockAlert").find("#globalMessages > .information_message").hasClass("positive")) {
                    jQuery("#FormStockAlert").find('.first').remove();
                    jQuery("#FormStockAlert").find('.last').show();

                }

        }).fail(function () {
                jQuery("#FormStockAlert #globalMessages").html('Sorry, an error has occured');
        });
    }
}


var Field = (function () {
    // Constructor
    var cls = function (name, order, type, rules, visible) {
        this.name = name; // Name of field
        this.order = order; // Dropdown lists steps values combination
        this.type = type; // Profile name
        this.rules = rules; // validation rules
        this.visible = visible; // is field visible by default
    };
    // Public methods
    cls.prototype = {
        getName: function () {
            return this.name;
        },
        getOrder: function () {
            return this.order;
        },
        getRules: function () {
            return this.rules;
        },
        isVisible: function () {
            return this.visible;
        },
        isMandatory: function () {
            return this.rules.indexOf("equired") >= 0;
        }
    };

    return cls;
})();


/* BRA-3294 */
$('#AccordionFAQ .accordion-toggle').on('click', function () {
    $('#faq #widget2').attr('width', '100%');
});
/* BRA-3294 */

$(function(){
    if ($('body').hasClass('page-productDetails') && $(document).width() < 768) {
        // get product details page modal
        var modal = $('.page-productDetails #ModalMedia');
        // register to 'shown' and 'hidden' modal events
        modal.on('shown', function() {
            cbModalShown();
        });
        modal.on('hidden', function() {
            cbModalHidden();
        });
        // register to onSlideBefore bxSlider event
        $(document).on('OnSlideBefore', function() {
            cbOnSlideBefore();
        });
        // modal shown callback
        function cbModalShown() {
            processItems();
        }
        // modal hidden callback
        function cbModalHidden() {
        }
        // click on the video overlay callback
        function cbClickVideoOverlay(overlay) {
            var _overlay = $(overlay);
            var iframe = _overlay.prev();
            _overlay.remove();
            // trigger click on play button
            iframe.attr('src', iframe.attr('src') + '&autoplay=1');
        }

        // onSlideBefore event handler
        function cbOnSlideBefore() {
            processItems();
        }

        // process items function
        function processItems() {
            // get all modal items
            var items = $('#CarouselDetailProductModal .item');
            // loop through each item
            items.each(function() {
                item = $(this);
                iframe = item.find('iframe').first();
                if (iframe.length === 1) {
                    // if item contain an iframe
                    item.addClass('item-alt');
                    // add item-alt class to the item
                    iframe.addClass('iframe-alt');
                    // add iframe-alt class to the iframe
                    if (item.find('.video-overlay').length === 0) {
                        item.append('<span class = "video-overlay" style="width:100%;height:100%;background:#000000;z-index:9999;top:0;left:0;opacity:0;position:absolute"></span>');
                        // append overlay to the iframe
                    }
                    item.find('.video-overlay').on('click', function() {
                        cbClickVideoOverlay(this);
                    });
                }
            });
        }
    }
});

//#BRA Add onclick to button see more
$(function(){
    $('.list-recipe .show-more').show();
    $('.list-recipe .seo-show-more').attr('style', "display:none;");
});

/*Nav bar product details*/

var btnClick = false;
$(window).scroll(function(){

    var position = $(window).scrollTop();
    var menuStikyProduct = 0;
    var positionToFixeIn = $(".push-banners").outerHeight(true) +  $(".recipes-banners").outerHeight(true) +  $("#master-detail-product").outerHeight(true) - 115 + $("#productGammes").outerHeight(true);
    var positionToFixeInProduct = $("#master-detail-product").outerHeight(false) - ( $(".bloc-communaute-questuion").outerHeight(true) + $(".bloc-dossier").outerHeight(true) + $(".bloc-download-apps").outerHeight(true)) ;

    /*

     if($(window).width() > 768){
     positionToFixeIn += $(".wrap-header").outerHeight(true) ;
     }
     */
    var postionTop =  position ;
    postionDown = position ;
    if($('.nav_lame').outerHeight(true)>116){
        postionTop = position -191;
        postionDown = position + 206;
    }


    $('.nav_lame a').each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));
        var refElementHeight = refElement.offset().top + refElement.outerHeight(true) - 180 ;

        if(!btnClick){

            var pos = refElement.offset().top - 180;
            var itsOkey = 10;

            if (refElement.offset().top - 180 <  postionDown + itsOkey && postionDown < refElementHeight ) {
                $('.nav_lame  li a').removeClass("active");
                currLink.addClass("active");
            }
            else {
                currLink.removeClass("active");
            }
        }
    });

    $('.nav_lame a:first').each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));
        if(!btnClick){
            if (refElement.position().top + refElement.height() - 180 > position  ) {
                $('.nav_lame  li a').removeClass("active");
                currLink.addClass("active");
            }
        }
    });
    if($(".item-compare")){

        positionToFixeInCompare = $("#master-slider-category").outerHeight(true) +  $(".sidebar-filters").outerHeight(true) + 20 ;
        lameNavHeight = $(".nav_lame").outerHeight(true);
        if(position >= positionToFixeInCompare){
            $(".item-compare").addClass("show");
        }else{
            $(".item-compare").removeClass("show");
        }
    }
    if($(".sticky-boutons")){
        menuStikyProduct = $(".sticky-boutons").outerHeight(true);

        if(position >= positionToFixeInProduct){
            $(".sticky-boutons").addClass("show");
        }else{
            $(".sticky-boutons").removeClass("show");
        }
    }
    if(position >= positionToFixeIn - 2  ){
        $(".nav_lame").addClass("fixed");
        /* add space that replace nav bar place to avoid content top jump */
        $(".lame-nav-space").css("margin-top",lameNavHeight+"px");
    }
    else{
        $(".lame-nav-space").css("margin-top","0px");
        $(".nav_lame").removeClass("fixed");
    }

});
/* BRA-5659 : Start*/
function checkRightToDeletAccount(element,event,checkCart) {
    var urlValidation = $($(element)).attr('data');
    var params = {"checkCart": checkCart};
    $.ajax({
        url: urlValidation, async: false, data:params
    }).done(function (data) {
        if(data == "CART_IN"){
            $("#ModalRemoveCart").show();
            $("#ModalRemoveCart").modal();
        }else if (data == 'NOK') {
            event.preventDefault();
            $("#ModalBlockDeleteAccount").show();
            $("#ModalBlockDeleteAccount").modal();
        }else if(data == 'OK'){
            event.preventDefault();
            $("#ModalDeleteAccount").show();
            $("#ModalDeleteAccount").modal();
        }

    }).fail(function (data) {
        event.preventDefault();
        console.log("Error in validing account deletion !");
    });
}
/* BRA-5659 : END*/

// SCROLL on anchor click
$('.nav_lame li a').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        var target = $(this.hash), mince = true;

        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

        if (target.length) {
            var scrollTopp = target.offset().top - ($('.wrap-header header').height() + $('.nav_lame').height());
            if(target.css('padding-top') == '0px' && target.find('.container').css('padding-top') == '0px') {
                scrollTopp = scrollTopp - 50;
                if($('.nav_lame').outerHeight(true) < 127) {
                    scrollTopp = scrollTopp - 127;
                }
                mince = false;
            } else if($(this).parent().prevAll().length == 0) {
                if($('.nav_lame').hasClass('fixed')) {
                    scrollTopp = scrollTopp + 50; //50 outer padding
                } else {
                    scrollTopp = scrollTopp - 53;//53 height of !fixed lame menu
                }
                mince = false;
            }else if(!$('.nav_lame').hasClass('fixed')) {
                scrollTopp = scrollTopp - 50;//50 height of !fixed lame menu
            }
            if($('.nav_lame').outerHeight(true) < 127 && mince) {
                scrollTopp = scrollTopp - 77;
            }

            btnClick = false;
            $('.nav_lame  li a').removeClass("active");
            $(this).addClass("active");

            $('html,body').animate({
                scrollTop: scrollTopp
            }, 900, function() {

                setTimeout(function(){
                    btnClick = false;
                }, 2000);

            });
            return false;
        }
    }
});

if($(window).width() > 768) {
    if ($('#master-detail-product').length > 0 && $('#master-detail-product .product-detail')) {
        var customMarge = $('#master-detail-product').height() - $('#master-detail-product .product-detail').height() - 20;
        if(customMarge > 0){
            $('#master-detail-product .product-price-quantity').css("margin-top", customMarge);
        }
    }
}

function initializeDatePicker() {
    var offsetCollectionDate = $("#offsetCollectionDate").val();
    var offsetReturnDate = $("#offsetReturnDate").val ();
    var selectedCollectDate;
    $ ( "#dateCollecte" ).datepicker ( {
        dateFormat: "dd/mm/yy",
        dayNames: [ "Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi" ],
        dayNamesMin: [ "Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa" ],
        dayNamesShort: [ "Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam" ],
        monthNames: [ "Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre" ],
        monthNamesShort: [ "Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aou", "Sep", "Oct", "Nov", "Déc" ],
        prevText: "<",
        nextText: ">",
        minDate: offsetCollectionDate,
        onSelect: function ( dateText ) {
            var dd = dateText.substring ( 0, 2 );
            var mm = dateText.substring ( 3, 5 );
            var yyyy = dateText.substring ( 6, 10 );
            var dateRetour = new Date ();
            dateRetour.setYear ( yyyy );
            dateRetour.setMonth ( mm - 1 );
            dateRetour.setDate ( dd );
            dateRetour.setDate ( dateRetour.getDate () + parseInt(offsetReturnDate));
            $ ( "#dateRetour" ).datepicker ( "option", "minDate", dateRetour );
        },
        beforeShowDay: function(date) {
            var day = date.getDay();
            return [(day != 0), ''];
        }
    } );
    $ ( "#dateRetour" ).datepicker ( {
        dateFormat: "dd/mm/yy",
        dayNames: [ "Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi" ],
        dayNamesMin: [ "Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa" ],
        dayNamesShort: [ "Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam" ],
        monthNames: [ "Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre" ],
        monthNamesShort: [ "Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aou", "Sep", "Oct", "Nov", "Déc" ],
        prevText: "<",
        nextText: ">",
        beforeShowDay: function(date) { // disable sundays
            var day = date.getDay();
            return [(day != 0), ''];
        }
    } );

    $('.ui-widget-header a span' )
        .removeClass('ui-icon' )
        .removeClass('ui-icon-circle-triangle-w')
        .removeClass('ui-icon-circle-triangle-e');
}


/* community managment*/
$ ( document ).ready ( function () {


    // insert slider
    //$('.sub-nav .container > ul').prepend('<li class="nav-follower"></li>');

    //var $navFllower = $(".nav-follower");

    // sliding
    /*$('.sub-nav .container ul li a').hover(function () {
        var left = $(this).parent().position().left + 18;
        var width = $(this).width() / 2;
        var margeCenter = width / 2;

        $('.nav-follower').stop().animate({
            'left': left,
            'width': width,
            'margin-left': margeCenter
        });
    });*/

    // If item Has class active
    if($('.sub-nav .container ul li').hasClass('active')) {

       /* // initially reset active
        var left = $('.sub-nav .container ul .active').position().left + 18;
        var width = $(".sub-nav .container ul .active").width() / 2 ;
        var margeCenterInit = width / 2;

        $navFllower
            .css({'left': left,'width': width,'margin-left': margeCenterInit})
            .data("origLeft", left)
            .data("origWidth", width )
            .data("origMarge", margeCenterInit );

        // Mouseleave
        $(".sub-nav .container ul li a").mouseleave(function() {
            $navFllower.stop().animate({
                left: $navFllower.data("origLeft"),
                width: $navFllower.data("origWidth"),
                'margin-left' : $navFllower.data("origMarge")
            });
        });*/
    }else {
        $('.sub-nav .container').addClass('hasNotActive');
        $(".sub-nav .container ul li a").mouseenter(function () {
            $(this).parents('.container').addClass('hover-active');
        }).mouseleave(function() {
            $(this).parents('.container').removeClass('hover-active');
        });
    }

    var tabs_options,
        numberOfSlides_questions,
        numberOfSlides_reviews,
        questions_count,
        reviews_count,
        carousel_questions_options,
        carousel_reviews_options,
        carousel_topRecette_options,
        disabled_tab_indexes = [];

    // questions
    numberOfSlides_questions = ($ ( document ).width () < 768) ? 1 : 2;
    carousel_questions_options = {
        minSlides: numberOfSlides_questions,
        maxSlides: numberOfSlides_questions,
        responsive: true,
        touchEnabled: true,
        adaptiveHeight: true,
        slideWidth: 440,
        slideMargin: 20,
        pager: false,
        controls: true
    };

    // init questions carousel
    community_questions_slider = $ ( '.community-answers-wrapper' ).bxSlider ( carousel_questions_options );

    // reviews
    numberOfSlides_reviews = ($ ( document ).width () < 768) ? 1 : 2;
    carousel_reviews_options = {
        minSlides: numberOfSlides_reviews,
        maxSlides: numberOfSlides_reviews,
        responsive: true,
        touchEnabled: true,
        adaptiveHeight: true,
        slideWidth: 440,
        slideMargin: 20,
        pager: false,
        controls: true
    };
    // init reviews carousel
    community_reviews_slider = $ ( '.community-reviews-wrapper' ).bxSlider ( carousel_reviews_options );

    // tabs
    if ($ ( '.community-tabs-wrapper .ui-tabs-nav .ui-tabs-anchor' ).first ().hasClass ( 'disabled' )){
        disabled_tab_indexes.push(0);
    }
    if ($ ( '.community-tabs-wrapper .ui-tabs-nav .ui-tabs-anchor' ).last ().hasClass ( 'disabled' )){
        disabled_tab_indexes.push(1);
    }
    tabs_options = {
        hide: { effect: "blind", duration: 1000 },
        disabled: disabled_tab_indexes, // array containing disabled tab indexes as integer
        collapsible: false,
        heightStyle: "content"
    };
    // init tabs
    $ ( "#community-tabs" ).tabs ( tabs_options );
    // activate tabs after initialization, must be optimized
    if ( $ ( '.community-tabs-wrapper .ui-tabs-nav .ui-tabs-anchor' ).first ().hasClass ( 'disabled' ) ) {
        $( "#community-tabs" ).tabs( "option", "active", 1 );
    } else {
        $( "#community-tabs" ).tabs( "option", "active", 0 );
    }



});


/* Sub Category Page */
$( document ).ready(function() {

    /* remove padding case menu burger was opened */
    if($(document).width() >= 768 && document.documentElement.scrollTop > 0 ){
        $('body').addClass("mini-header");
    }

    /* Redimensionner bloc centre reparation */
    redimensionnerStore('.page-my-repairers .details-store-off .inner');

    /* Add sort to select */
    $(".template-pages-NewsLetterPageTemplate.page-newsletter .form-horizontal .row-fluid .control-group select,#FormUserIds select,#AddAddressForm select,.display-filters-faq select").wrap("<div class='sort'></div>");
    $('.template-pages-AccountPageTemplate .addrBookContainer .btn-action').on('click',function () {
        $(document).ajaxComplete(function(){
            $(".addrFormContainer select").wrap("<div class='sort'></div>");
        });
    });

    /* Change img to canvas for RS */
    $('.social-media-navtop li img.clone').each(function () {
        Caman(this, function(){
            this.contrast(-100);
            this.render();
        });
    });

    /* Change name accessory & claim push 4 position page home accessorie */
    $('.page-AccessoriesHomePage .mini-banners .banners-right .banner-4 .head-title a').html($('.page-AccessoriesHomePage .mini-banners .banners-right .banner-4 .caption .description').text());
    $('.page-AccessoriesHomePage .mini-banners .banners-right .banner-4 .head-title a').css({ 'display' : 'block' });
    /* Change positions bloc page account */
    $('.template-pages-AccountPageTemplate .sidebar-filters form[name="search_form_rp"]').insertAfter($( ".template-pages-AccountPageTemplate .row-fluid.bloc-light .orders-user"));
    $('.template-pages-AccountPageTemplate .main-content #globalMessages').prependTo('.template-pages-AccountPageTemplate .main-content > .row-fluid .span9');
    $('.template-pages-AccountPageTemplate .display-filters.display-filters-faq').parents('.row-fluid').next().hide();
    $('.page-MultiStepCheckoutSummaryPage .cart-list-table .product-detail,.page-OrderConfirmationPage .cart-list-table .product-detail').each(function () {
        $(this).find('.value').appendTo($(this));
    });

    $('.bloc-banner-item .container .banner-top .caption .trigger').on('click', function(e) {
        e.preventDefault();
        var $this = $(this);

        $this.toggleClass('open');
        $this.parents('.banner-top').next().stop().slideToggle('slow');
    });


    /* Modals Handler */
    $("a[data-target=\\#ModalMessage]").click(function(e) {
      e.preventDefault();
      if ($(this).attr("href") != null && $(this).attr("href") != "#") {
        $.ajax({
          type: "get",
          url: $(this).attr("href")
        })
          .done(function (data) {
            $("#ModalMessage .modal-body").html(data);
            $("#ModalMessage").modal('show');

          })
          .fail(function () {
            $("#ModalMessage .modal-body").html("Error Retrieving content from : " + $(this).attr("href"));
            $("#ModalMessage").modal('show');
          });
      } else {
        $("#ModalMessage").modal('show');
      }
    });

  $("#ModalMessage").on('hidden.bs.modal', function () {
    $("#ModalMessage .modal-body").empty();
  });

    $("a[data-target=\\#ModalTOS]").click(function(e) {
        e.preventDefault();

        var target = $(this).attr("href");
        var title = $(this).attr("title");


        // load the url and show modal on success
        $("#ModalTOS .modal-body").on('load',target, function() {

            if ($("#ModalTOS .modal-body").find("h1").length) {
                title = $("#ModalTOS .modal-body").find("h1").text();
            }

            $("#ModalTOS .modal-header").html(title);

            $("#ModalTOS").modal("show");

            $(document).ajaxComplete(function(){
                $("#ModalTOS .modal-body ").find("h1").hide();
            });
        });

    });

    // Popin FormStockAlert
    $('#ModalMessage').on('show', function () {
        var $this = $(this);
        $(document).ajaxComplete(function(){
            if ($this.find('#FormStockAlert').length > 0) {
                $this.addClass('FormStockAlert');
            }
        });
    });

    if ($(window).width() < 768) {
        $('.page-recipe-details .fiche-recette .bloc-product > .visuel').insertAfter(".page-recipe-details .fiche-recette .bloc-product .caption .infos-recette");
        $('.filters-recipes .active-filters').insertAfter(".filters-recipes #recipe-search");
        $('.fiche-recette .bloc-product .caption .comments-share').insertBefore('#services');
        $('.page-AccessoryFinishedProductDetailPage .lame-triman').appendTo('.page-AccessoryFinishedProductDetailPage .bloc-product .product-detail');

        $('.wrap-footer .footer .footer-left').appendTo('.wrap-footer .footer');
        $('.wrap-footer .bottom-footer-links .our-products').prependTo('.wrap-footer .footer .footer-left>ul');
        $('.page-recipe-details #master-detail-product .product-viewer').insertBefore('.page-recipe-details #master-detail-product .product-detail .product-detai-content .recipe-step');
        $('#master-detail-product .product-viewer').insertBefore('#master-detail-product .product-detail .product-detai-content .product-short-description');
        $('.sub-nav').insertBefore('.main-footer .services');
        $('.page-AccessoriesHomePage .mini-banners .banners-left .banner .visuel').insertAfter('.page-AccessoriesHomePage .mini-banners .banners-left .banner .caption .seconde-title');

        $(window).on('resize', function() {
            if($(".wrap-home-recipe .krups-push-wrapper.recipe-section .caption-section").length > 0) {
                //recipeMobile();
            }
        });

        $("section.krups-push-wrapper.wrap-citations").each(function(index){
            var $contCitation = $($(this).find('.cont-section'));
            $(this).find('h2').prependTo($contCitation);
            $(this).find('.author').appendTo($contCitation);
        });
    }
//	else{
    // KRUP-1674: Désactiver les entrées de la V2 sur le footer
    // a supprimer en V2
//		$( ".footer-left ul.social-media li:nth-child(4) h3" ).css('visibility', 'hidden');
//		$( ".footer-left ul.social-media li:nth-child(4) ul" ).css('visibility', 'hidden');
//	}

    $(".designed .slider-4 > .item").each(function(index){
        $(this).find('.visuel').prependTo($(this));
    });


    //Inject Random Banners
    if ($(".list-product").length) {
        $(".list-product .range .list-content")
        var numberProd = $(".list-product .range .list-content .item").length;

        //generating 3 differents random numbers < numberProd

        if (numberProd>3) {
            var arr = []
            while(arr.length < 3){
                var randomnumber=Math.floor(Math.random()*numberProd)
                var found=false;
                for(var i=0;i<arr.length;i++){
                    if(arr[i]==randomnumber){found=true;break}
                }
                if(!found)arr[arr.length]=randomnumber;
            }
        }else {
            var arr = [0,1,2]
        }

        //inject banners
        $("#sub-category-banners-list").hide();
        $("#sub-category-banners-list .push-banner").each(function(index){
            if (index < numberProd) {
                $(".list-product .range .list-content .item:eq("+arr[index]+")").after($(this));
            }

        });
    }

    // Label Focus
    $('.wrap-footer .newsletter label').on('click', function () {
        $(this).prev().focus();
    });

    $('.wrap-footer .newsletter input[type=email]').focusout(function () {
        $('.wrap-footer .newsletter .form-groupe').removeClass('focus');
    });
    $('.wrap-footer .newsletter input[type=email]').focus(function () {
        $(this).closest('.form-groupe').addClass('focus');
    });

    // Input Kepress Filled  Focus
    $('.wrap-footer .newsletter input[type=email]').keyup(function () {
        if ($(this).val().length > 0) {
            $(this).closest('.form-groupe').addClass('filled');
        } else {
            $(this).closest('.form-groupe').removeClass('filled');
        }
    });

    // Input Check Filled Focus
    var $formControl = $('.wrap-footer .newsletter input[type=email]'),
        values = {},
        validate = $formControl.each(function () {
            if ($(this).val().length > 0) {
                $(this).closest('.form-groupe').addClass('filled');
            } else {
                $(this).closest('.form-groupe').removeClass('filled');
            }
        });


    $('.anchor-list ul li a').click(function () {
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - ($('.wrap-header').height() + 30)
        }, 500);
        return false;
    });

    if($('body').hasClass('page-SubCategoryPage') || $('body').hasClass('page-productDetails')) {
        var maxLinesToDisplay = 3 ;
        $('.excerpt.claim').each(function(){
            $clamp(this, {clamp: maxLinesToDisplay});
        });
    }

});


/* End Sub Category Page */

/**
 * recipes query constructor
 *
 */

$(".filters .filter-items .radios-groups").each(function(){

    $(this).find(":input:radio").change(function(){
        recipes_form_query_constructor();
    });
});

$('#search_form_recipe_submit').click(function () {

    var q = $("#search_form_recipe").find('input[name="q"]').val();
    q = $("#search_form_recipe").find('input[name="text"]').val() + q;

    $("#search_form_recipe").find('input[name="q"]').val(q);

    $('#search_form_recipe').submit();
});

function recipes_form_query_constructor(){

    //Initialize query
    var q ="::";

    //build query
    $(".filters").each(function(){

        $(this).find(".filter-categories a.active").not(".seeAll").each(function(){
            var query_input = $(this).parent().find('input[name="q"]').attr("data-query");
            if (q.indexOf(query_input) >= 0){
                q = q.replace(query_input+':', '');
            }else {
                q = q + query_input +":";
            }
        });

        $(this).find(".filter-items .radios-groups").each(function(){
            var radio_input = $(this).find('input[type="radio"]:checked').not(".whatever");
            if(radio_input){
                var query_input = radio_input.attr("data-query");
                if (typeof query_input != 'undefined' && query_input!='undefined'){
                    if (q.indexOf(query_input) >= 0){
                        q = q.replace(query_input+':', '');
                    }else {
                        q = q + query_input +":";
                    }
                }
            }
        });

        $("#search_form_recipe").find('input[name="q"]').val(q);
//		console.log(q);

    });

}

$(".filter-items .radios-groups").each(function(){
    var radio_input = $(this).find('input[type="radio"]:checked').not(".whatever").length;
    if(radio_input==0){
        $(this).find('input[type="radio"].whatever').attr("checked","checked");
    }
});
/*
 function form_query_constructor(){


 $(".filters .accordion-group").each(function(){
 var q = "";
 $(this).find(".allFacetValues .facet_block form.active").each(function(index){
 if (index == 0) {
 q = q + $(this).find('input[name="q"]').val();
 }else {
 q = q + ":" +  $(this).find('input[type="checkbox"]').attr('data-query');
 }
 });

 $(this).find(".allFacetValues #main_form").find('input[name="q"]').val(q);

 });


 }
 */

$(function(){
    /**
     * Our history ScrollSpy
     */
    var scrollSpy = $('.panel-history');
    if(scrollSpy){
        /**
         * On exit callback
         */
        scrollSpy.on('scrollSpy:exit', function () {
            $('a[href =\\#' + $(this).attr('id') + ']').removeClass('active');
        });

        /**
         * On enter callback
         */
        scrollSpy.on('scrollSpy:enter', function () {
            $('a[href ~=\\#' + $(this).attr('id').substring(0, 7) + ']').removeClass('active');
            $('a[href =\\#' + $(this).attr('id') + ']').addClass('active');
        });

    }
});

$(function () {
    $(document).on('initialized.owl.carousel', '.carousel.invisible', function (event) {
        var $this = $(this);
        $this.removeClass('invisible');
        $this.parent().find('.spinner').remove();
    });
});


$('#ModalMedia').on('hidden.bs.modal', function () {
    $('body').removeClass('open-popin');
    if($('#ModalMedia').find('iframe')[0] != undefined) {
        $('#ModalMedia').removeData();
        $('#ModalMedia').find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
    }
});


$(function () {
    if($('.our-applications').length > 0){

        /**
         * Our apps carousel options
         * @type {{}}
         */
        var ourApplicationsCarouselOptions = {
            items: 4,
            loop: true,
            lazyLoad : true,
            margin: 0,
            navigation : true,
            navRewind: false,
            pagination: true,
            responsiveRefreshRate : 100,
            dots: false,
            responsive : {
                0 : {
                    items: 1,
                    margin: 0,
                    center: true,
                    dots: false
                },
                768 : {
                    items: 2,
                    margin: 0
                },
                1024 : {
                    items: 4,
                    margin: 0
                }
            }
        };

        /**
         * Our apps carousel init
         */
        $('.MobileApplicationListPageCarouselWrapper ul').owlCarousel(ourApplicationsCarouselOptions);
    }
});

$ (function () {
    if (window.innerWidth <= 1200) {
        // Mobile && Tablet
        var AppStoreLink = false;
        var GooglePLayLink = false;
        if ($ ('.MobileApplicationAppStoreLink').length > 0) {
            AppStoreLink = true;
        }
        if ($ ('.MobileApplicationGooglePlayLink').length > 0) {
            GooglePLayLink = true;
        }
        if (AppStoreLink & !GooglePLayLink) {
            $ ('.MobileApplicationAppStoreLink img').css ({'float' : 'none'});
        }
        if (!AppStoreLink & GooglePLayLink) {
            $ ('.MobileApplicationGooglePlayLink img').css ({'float' : 'none'});
        }
    }
    if($('.MobileApplicationListPageCarouselWrapper li').length < 4){
        $('.MobileApplicationListPageCarouselWrapper').hide();
    }
});

$(function () {
    if ($('[id*="ModalMedia"]').length >= 1) {
        $('[id*="ModalMedia"]').each(function () {
            var that = $(this);
            that.on('shown', function () {
                setTimeout(function () {
                    if (that.find('iframe').length === 1 && that.find('img').length <= 0) {
                        that.addClass('transparent-modal');
                        if($('.transparent-modal-close').length <= 1){
                            //that.find('button.close').appendTo('.transparent-modal .item.active').wrap('<div class="transparent-modal-close"></div>');
                        }
                    }
                }, 500);
            });
        });
    }
});


$ ( document ).ready ( function () {
    $('a.play-video-reparability').attr("data-toggle","modal");//.play-video-reparability existe in MainContentReparabilityParagraph
    $('a.play-video-reparability').attr("data-target","#ModalMedia");
    /*Start :KRUP-86*/
    if ($('input[name="superCategoryCode"]').length >= 1) {
        var inputValue=$('input[name="superCategoryCode"]').val();
        if(inputValue && inputValue !=null){
            var codeCategory="superCategoryCode="+inputValue;
            $("a").not(".main-nav a,.wrap-footer a, a.accordion-toggle").each(function () {
                var xhref=$(this).attr("href");
                $(this).attr("href",xhref + (xhref.indexOf('?')>0 ? "&":"?")+codeCategory);
            });
        }
    }
    /*End :KRUP-86*/

    /*Start :KRUP-322*/
    $(function () {
        if ($('.hubUnivers').length >= 1 && $('#Htimetoshop').length==0) {
            $('.hubUnivers .scroll-icon').attr('data-target','krups-section-2');
        }
    });
    /*End :KRUP-322*/
    if($("h1").length==0){
        $(".wrap-header").append("<h1 class='defaultTitle hide'>"+deafultTitle+"</h1>");
    }
    if($("a.tooltip-bottom.seeAll").length > 0 && $("a.tooltip-bottom.seeAll").hasClass("active")){
        $("a.tooltip-bottom").addClass("active");
    }
});


$(window).scroll(function () {

    if ($('.page-ProductComparatorPage').length && $(window).width() > 768 ) {
        var headHeightToFixTable = $(".wrap-header header").outerHeight() + 45;
        var currentHeadHeightFromTop = parseInt($('.floatThead-container').css("top"));
        console.log("headHeightToFixTable" + headHeightToFixTable);
        console.log("currentHeadHeightFromTop " + currentHeadHeightFromTop );
        if(currentHeadHeightFromTop == headHeightToFixTable )
        {
            $('.floatThead-container').addClass('shadow');
        }
        else
        {
            $('.floatThead-container').removeClass('shadow');
        }
        $('#ScrollabeTableCompare tbody').find('tr').each(function () {
            var heightFromTop = $(this).offset().top - $(document).scrollTop();
            var theadAverageHeight = 90;
            if (heightFromTop < headHeightToFixTable + theadAverageHeight ) {
                $(this).css('visibility', 'hidden');
            }
            else {
                $(this).css('visibility', '');
            }
        })

    }
});

function coverImageProcess(selector) {
    if(selector) {
        $(selector).find('.cover-image').css('height', $(window).height() + 'px');
    } else {
        selector = '.cover-image';
    }

    $(selector).find('img').each(function(i, elem){
        var width = '100%';
        var height = '100%';

        if($(this).hasClass("demi") && $(window).width() > 768 )  {
            width = '50%';
        }

        var position = 'center';
        if($(elem).attr('left') != undefined && $(window).width() < 768) {
            position = $(elem).attr('left') + ' center';
        }
        if($(elem).attr('dleft') != undefined && $(window).width() > 768) {
            position = $(elem).attr('dleft') + ' center';
            if($(elem).attr('dtop') != undefined && $(window).width() > 768) {
                position = $(elem).attr('dleft') +  $(elem).attr('dtop');
            }
        }

        if(typeof $(this).attr('data-src') !== 'undefined' && $(this).attr('data-src') !== 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7') {
            $(this).css({
                backgroundSize : 'cover',
                backgroundImage : 'url("' + $(this).attr('data-src') + '")',
                backgroundPosition : position,
                height : height,
                width : width
            });
        }

        $(this).attr('data-src','data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7');
    });
}
coverImageProcess();

function load_read_more_content(){
    $('.product-content-short-description').html($('.full-product-content-short-description').html());
}

$("#register-new-user").click(function(){
    $('.dropmenu.open').removeClass('open');
    $('.modal-backdrop').remove();
});

$(".forgotten").click(function(){
    $('body').removeClass('open-search');
});


/**
 * *************** [BEGIN] BRA-5345 | Special Offers V2 Rowenta Desktop ***************
 */

if($(".special-offers-v2-filters").length > 0) {

    Isotope.Item.prototype._create = function () {
        // assign id, used for original-order sorting
        this.id = this.layout.itemGUID++;
        // transition objects
        this._transn = {
            ingProperties: {},
            clean: {},
            onEnd: {}
        };
        this.sortData = {};
    };

    Isotope.Item.prototype.layoutPosition = function () {
        this.emitEvent('layout', [this]);
    };

    Isotope.prototype.arrange = function (opts) {
        // set any options pass
        this.option(opts);
        this._getIsInstant();
        // just filter
        this.filteredItems = this._filter(this.items);
        // flag for initalized
        this._isLayoutInited = true;
    };

    // layout mode that does not position items
    Isotope.LayoutMode.create('none');
}

function removeDuplicates(arr, prop) {
    var new_arr = [];
    var lookup  = {};

    for (var i in arr) {
        lookup[arr[i][prop]] = arr[i];
    }

    for (i in lookup) {
        new_arr.push(lookup[i]);
    }

    return new_arr;
}

$(function(){
//
//    var filters = $(".special-offers-v2-main").find("[data-category]");
//    var categories = [];
//    filters.each(function(){
//        var picto = $(this).attr("data-picto");
//        var name = $(this).attr("data-category");
//        var pictoHover = $(this).attr("data-pictohover");
//
//        var category = {
//            "picto" : picto,
//            "name" : name,
//            "pictoHover" : pictoHover
//        }
//
//        categories.push(category);
//    });
//
//    var uniqueCategories = removeDuplicates(categories, "name");
//
//    //Filters
//    $.each(uniqueCategories, function (index, element) {
//        var filterClass = element.name.replace(/\s/g, "");
//
//        $("<div data-filter='" + filterClass + "' class='filter'>" +
//            "<div class='picto'><span class='helper'></span><img src='" + element.picto + "'/><img src='" + element.pictoHover + "'/></div>" +
//            "<div class='caption std'>" + element.name + "</div>" +
//            "</div>").insertAfter($(".special-offers-v2-filters .filterText"));
//
//        $("<div data-filter='" + filterClass + "' class='filter'>" +
//            "<div class='picto'><span class='helper'></span><img src='" + element.picto + "'/></div>" +
//            "<div class='caption'>&nbsp;" + element.name + "</div>" +
//            "</div>").insertBefore($(".special-offers-v2-filters-mobile .separator"));
//
//
//    });
//
//    var $filterlame = $(".special-offers-v2-container").isotope({
//        itemSelector: '.special-offers-v2-component',
//        layoutMode: 'none'
//    });
//
//    $('.special-offers-v2-filters .filter').click(function() {
//        var filterValue = $(this).attr('data-filter');
//        if(filterValue == '*'){
//            $filterlame.isotope({
//                filter: "*",
//                hiddenStyle: {
//                    opacity: 0,
//                    transform: 'scaleY(0.001)'
//                },
//                visibleStyle: {
//                    opacity: 1,
//                    transform: 'scaleY(1)'
//                }
//            });
//        } else {
//            $filterlame.isotope({
//                filter: "." + filterValue,
//                hiddenStyle: {
//                    opacity: 0,
//                    transform: 'scaleY(0.001)'
//                },
//                visibleStyle: {
//                    opacity: 1,
//                    transform: 'scaleY(1)'
//                }
//            });
//        }
//    });
//
//    //Categories Display
//    var displayCategoriesPictos = [];
//    var uniqueCategoriesPictos = [];
//
//    $(".special-offers-v2-main").each(function(index, element) {
//
//        var main = $(this);
//
//        main.find("[data-category]").each(function () {
//
//            var picto = $(this).attr("data-picto");
//            displayCategoriesPictos.push(picto);
//
//        });
//
//        for (var i = 0; i < uniqueCategories.length; i++) {
//            uniqueCategoriesPictos.push(uniqueCategories[i].picto);
//        }
//
//
//        for (var i = 0; i < uniqueCategoriesPictos.length; i++) {
//
//            var element = uniqueCategoriesPictos[i];
//
//            if ($.inArray(element, displayCategoriesPictos) != -1) {
//                main.find("p.category").append("<div class='catPicto active'><span class='helper'></span><img src='" + element + "'/></div>")
//            } else {
//                main.find("p.category").append("<div class='catPicto'><span class='helper'></span><img src='" + element + "'/></div>")
//            }
//        }
//
//        displayCategoriesPictos = [];
//        uniqueCategoriesPictos = [];
//
//    });
//
    $(".special-offers-v2-main .moreInfo").click(function(){
        $(".sp-offer-detailed-info").slideUp();
        $(".lessInfo").hide();
        $(".moreInfo").show();
        $(this).hide();
        $(this).siblings(".lessInfo").show();
        $(this).closest(".sp-offer-basic-info").siblings(".sp-offer-detailed-info").find(".lessInfo").show();
        $(this).closest(".sp-offer-basic-info").siblings(".sp-offer-detailed-info").slideDown();
    });


   $(".special-offers-v2-main .lessInfo").click(function () {
       $(this).closest(".sp-offer-basic-info").siblings(".sp-offer-detailed-info").slideUp();
       $(this).siblings(".moreInfo").show();
       $(this).hide();
   });


   $(".special-offers-v2-details .lessInfo").click(function(){
       $(this).closest(".sp-offer-detailed-info").slideUp();
       $(this).closest(".sp-offer-detailed-info").siblings(".sp-offer-basic-info").find(".moreInfo").show();
       $(this).closest(".sp-offer-detailed-info").siblings(".sp-offer-basic-info").find(".lessInfo").hide();
   });
//
//    $(".special-offers-v2-filters .filter").click(function(){
//
//        $(".sp-offer-detailed-info").slideUp();
//        $(".lessInfo").hide();
//
//        $(".moreInfo").show();
//
//        $(".special-offers-v2-filters .filter").removeClass("active");
//        $(this).addClass("active");
//    });
//
//    //Carousel
//    $(".special-offers-v2-main .moreInfo").click(function(){
//
//        var slider = $(this).closest('.sp-offer-basic-info').siblings('.sp-offer-detailed-info').find(".slider-spOffers");
//
//        if(!isMobile && slider.attr("data-visible") < slider.find(".item").length) {
//
//            slider.bxSlider({
//                pager: false,
//                infiniteLoop: true,
//                minSlides: 3,
//                maxSlides: 3,
//                slideWidth: 340,
//                moveSlides: 1
//            });
//
//        } else if (isMobile && 1 < slider.find(".item").length){
//
//            slider.bxSlider({
//                pager: false,
//                infiniteLoop: true,
//                minSlides: 1,
//                maxSlides: 1,
//                slideWidth: 250,
//                moveSlides: 1
//            });
//
//        }
//
//    });
//
//    //Banner
//    if($(".specialOfferBanner").length > 0){
//        if(!isMobile){
//            var banner = $(".specialOfferBanner .sp-offer-desktop-banner").find("img").attr("src");
//        } else {
//            var banner = $(".specialOfferBanner .sp-offer-mobile-banner").find("img").attr("src");
//        }
//        $(".specialOfferBanner").css("background-image", "url('"+banner+"')");
//    }
//
//    //Mobile
//    $(".special-offers-v2-filters-mobile .filter").click(function(){
//        $(".moreInfo").show();
//        $(".lessInfo").hide();
//        $(".sp-offer-detailed-info").slideUp();
//        $(".special-offers-v2-filters-mobile .filter").removeClass("active");
//        $(this).addClass("active");
//    });
//
//    $(".special-offers-v2-filters-mobile .accordion-heading").click(function(){
//        $(this).find("span").toggleClass("active");
//    });
//
//    $('.special-offers-v2-filters-mobile .filter').click(function() {
//        var filterValue = $(this).attr('data-filter');
//        if(filterValue == '*'){
//            $filterlame.isotope({
//                filter: "*",
//                hiddenStyle: {
//                    opacity: 0,
//                    transform: 'scaleY(0.001)'
//                },
//                visibleStyle: {
//                    opacity: 1,
//                    transform: 'scaleY(1)'
//                }
//            });
//        } else {
//            $filterlame.isotope({
//                filter: "." + filterValue,
//                hiddenStyle: {
//                    opacity: 0,
//                    transform: 'scaleY(0.001)'
//                },
//                visibleStyle: {
//                    opacity: 1,
//                    transform: 'scaleY(1)'
//                }
//            });
//        }
//    });
});

/**
 * *************** [END] BRA-5345 | Special Offers V2 Rowenta Desktop ***************
 */

//BRA-7800
$(window).on('load',function(){

    if ($(document).width() < 768) {
        isMobile = true;
    } else {
        isMobile = false;
    }

    if($(".detachedPiece-PDP .detachedPieceType2").length > 0){
        if(!isMobile) {
            $(".detachedPiece-PDP .detachedPieceType2").height(
                $("div.buttons.detachedPiece-PDP > img").height() + 1);
            $(window).resize(function () {
                $(".detachedPiece-PDP .detachedPieceType2").height(
                    $("div.buttons.detachedPiece-PDP > img").height() + 1);
            });
        }
    }

    if ($(window).width() < 768) {
        recipeMobile();
    }

});

if ($(window).width() < 768) {
    //Recipe mobile
    function recipeMobile() {
        $(".wrap-home-recipe .krups-push-wrapper.recipe-section .caption-section").each(function(index){
            var $contRecipe = $($(this).parent().find('.list-home-recipe .caption'));
            $(this).find('.cont-section').clone().prependTo($contRecipe);
            $(this).hide();
            $contRecipe.each(function(index){
                var $this = $(this).find('.cont-section');
                $(this).parents('.list-home-recipe').prev().css('top' , $this.position().top + $this.outerHeight(true) - 60 );
            });
        });
    }
    //recipeMobile();
}

// List culture krups page - get MORE
$(document).on('click', '.culture-home.search-result .container .more a', function (event) {
    event.preventDefault();
    $('.more').hide();
    var url = $(this).attr("href");
    $.ajax({
        url: url,
        type: 'GET',
        dataType: 'html',
        data: ''
    }).always(function (data) {
      $('#grid').append(data);
      $('.search-result .container').append($("div.more"));
      new GridScrollFx(document.getElementById('grid'));
    });
});
if($('#culture-popin').length > 0) {
    $(document).on('click', 'a.recipe-in-popin', function (event) {
        event.preventDefault();
        var url = $(this).attr("href");
        var params = {"isPopin": true};

        $('.modal-recipe .modal-body').empty();
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'html',
            data: params
        }).always(function (data) {
          $('#culture-popin').removeClass('hidden');
          $('#culture-popin .culture-popin-content').empty().append(data);
          $('.culture-search, .search-result').addClass('hide');

          $("body, html").animate({
            scrollTop: $('.master-ban-head').height() - 65
          }, 600);

          var recipeCarousel = $('.recipe-carousel ul');
          recipeCarousel.each( function(item) {
            var item_amount = parseInt( $(this).find('.item').length);
            var hasDesigned = $(this).parents('.designed');
            var carouselDots = false;
            if($('#CarouselRecettesPreferees').length > 0) {
              carouselDots = true
            }
            $(this).owlCarousel({
              items: 3,
              slideBy: 3,
              margin: 20,
              lazyLoad: true,
              pagination: false,
              rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false,
              nav: item_amount > 3 ? true:false,
              dots: carouselDots,
              responsiveRefreshRate: 100,
              responsive : {
                0 : {
                  items:  hasDesigned.length > 0 ? 1.5:1.18 ,
                  slideBy: hasDesigned.length > 0 ? 1.5:1.18 ,
                  center: item_amount > 1 ? true:false,
                  mouseDrag: true,
                  autoHeight: true,
                  adaptiveHeight: true,
                  loop: true
                },
                768 : {
                  items: 3,
                  slideBy: 3,
                  center: false,
                  autoHeight: false,
                  mouseDrag: false,
                  adaptiveHeight: false,
                  loop: item_amount > 3 ? true:false
                }
              }
            });

            if($(this).find('.owl-dots .owl-dot').length == 1) {
              $(this).find('.owl-dots').remove();
            }

          });

          if ($(document).width() <= 768) {
            $('.accordion-panel').not('.content-mosaic-ban .accordion-panel').each(function () {
              var accordionPanelHeiht = $(this).height(),
                element = $(this);
              if ( element.find("h2:first-child").length ) {
                elementTitle = element.find("h2:first-child");
              }else{
                elementTitle = element.find(".accordion-panel-title");
              }

              titleHeiht = elementTitle.outerHeight();

              element.height(titleHeiht).addClass('active');

              elementTitle.on('click', function (e) {
                e.preventDefault();
                element.toggleClass('open');
                //tog.height(accordionPanelHeiht);
                if(element.hasClass('open') && !element.hasClass('colspad') ){
                  $(this).addClass('active');
                  element.addClass('colspad');
                  element.animate({
                    height: accordionPanelHeiht
                  }, 600, function() {
                    element.css('height', 'auto');
                    element.removeClass('colspad');
                  });

                }else if(!element.hasClass('colspad')){
                  $(this).removeClass('active');

                  element.addClass('colspad');
                  element.animate({
                    height: $(this).outerHeight()
                  }, 500, function() {
                    element.removeClass('colspad');
                  });
                }

              });

            });

            // block-machine carousel
            var carouselSectionBlocs = $(".list-resipe-machine");
            carouselSectionBlocs.owlCarousel({
              center: true,
              items: 1.12,
              margin: 12,
              navigation : true,
              navRewind: false,
              pagination: false,
              nav: false,
              dots: false,
              rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false,
              responsiveRefreshRate : 100
            });

          }

          if ($(document).width() > 768) {
            var heElement = $('.product-detail').outerHeight();
            $('.product-viewer-content .visuel').css('height', heElement + 'px');
            if ($('.product-viewer-content.video-content').length > 0) {
              var vHieght = heElement - 190;
              $('.product-viewer-content.video-content [data-target="#ModalMedia"]').css('height', vHieght + 'px');
            }
          }
        });
    });

    $('.culture-popin-close').on('click', function() {
        $('.culture-search, .search-result').removeClass('hide');
        $('#culture-popin').addClass('hidden');
    })
}

if($('.trigger-search').length > 0) {
    $('.trigger-search, .search-wrapper .close').on('click', function() {
        $('.search-wrapper').toggleClass('hide');
        $('#NoResult').hide()
    })
    if ($(document).width() > 768 && $('.no-results').length === 0) {
        $('.home-culture .culture-search .container .cont-search').css('width', $('.home-culture .search-result .grid-wrap ul').width() - 32 + 'px');
    }
}

if(($('.home-culture').length > 0 || $('.page-Lartdelad-gustation').length > 0) && $(document).width() > 768) {
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) == false) {
        $(window).resize(function(){location.reload();});
    }
}
if($('.home-culture').length > 0 || $('.page-Lartdelad-gustation').length > 0) {
    window.addEventListener("orientationchange", function() {
        location.reload();
    }, false);
}

$('select.culture-facet').on('change', function() {
    var q ="";
    $("select.culture-facet").each(function(index){
        var optionSelected = $(this).find("option:selected");
        var query_input = $(optionSelected).attr("data-query");
        if (typeof query_input != 'undefined'){
            q = q + query_input +":";
        }

    });
    $("#search-form-culture").find('input[name="text"]').val("");
    q="::theme:Culture page:includeInCulture:true:"+q;
    $("#search-form-culture").find('input[name="q"]').val(q);
    $("#search-form-culture").submit();

})


$('.recipe-media .recipe-btn').on("click", function(e) {
			e.preventDefault();
			console.log($(this).data("href"));
			$.ajax({
	        	type : "get",
	            url : $(this).data("href"),
            }).done(Modal.displayModal
            ).fail(function () {
	                console.error("Error Retrieving content from" + $(this).data("href"));
	        });
		})

function handleProductGalleryCarousel() {
// Carousel Detail Product Big
    if (isMobile && $('#CarouselDetailProductBig .carousel-inner span, #CarouselDetailProductBig .carousel-inner div').length > 1) {

        var detailProductSliderOptions = {
            stageElement: "ul",
            itemElement: "li",
            loop: true,
            dots: true,
            nav: false,
            touchDrag: true,
            items: 1,
            slideBy: 1,
            rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false

        }
        var $detailProductSlider = $('#CarouselDetailProductBig .carousel-inner');
        $detailProductSlider.owlCarousel(detailProductSliderOptions);

    }
}
handleProductGalleryCarousel();
/*
 * [BRA-11254] - Non-rechargement de la page Sous-Catégorie lors de la Validation des Filtres
 */
$(document).ready(function () {

    function comparatorComposite() {
        initGoCompare();
        refresh_compare();
    }

    function stringToUrl(url) {
        var parser = document.createElement('a');
        parser.href = url;
        return parser;
    }

    function pushParamsToHistoryState(url) {
        history.pushState({}, 'queryParams', stringToUrl(url).search);
    }

    function getSelectedFilterUrl(element, link) {

        if (element.closest(".subCatSelectedFacet").hasClass("btn-reset")) {
            return [link.protocol, '//', link.host, '/', link.pathname].join('');
        } else {
            return [link.protocol, '//', link.host, '/', link.pathname, '/async', link.search].join('');
        }

    }

    function appendResultToHTML(result){
        $("#plp-selected-facets-section").html($(result).find("#plp-selected-facets-section").html());
        $("#plp-facets-section").html($(result).find("#plp-facets-section").html());
        $("#plp-pagination-section").html($(result).find("#plp-pagination-section").html());
        $("#plp-results-section").html($(result).find("#plp-results-section").html());
        $("#plp-result-count-section").html($(result).find("#plp-result-count-section").html());
    }

    function submitForm(result) {
        var placeholderForm = $(result).find("#plpRedirectForm").first();
        $(document.body).append(placeholderForm);
        placeholderForm.submit();
    }

    $(document).on("change", ".subCatFacet, .subCatPagination", function (event) {

        //Stop event from triggering twice.
        event.stopImmediatePropagation();

        var element = $(event.target);
        var form = element.closest("form");

        $("#plp-results-section").addClass("ajax-overlay");

        $.ajax({
            type: 'GET',
            url: element.data("current-cat-url") + '/async',
            data: form.serialize()
        }).done(function (result, textStatus, jqXHR) {

                if ($(result).find("#plp-data [name='redirect']").val()) {

                    submitForm(result);

                } else {

                    pushParamsToHistoryState(this.url);

                    appendResultToHTML(result);

                    comparatorComposite();

                    $("#plp-results-section").removeClass("ajax-overlay");
                }

        }).fail(function () {

                $("#plp-results-section").removeClass("ajax-overlay");

        });

    });

    $(document).on("click", ".subCatSelectedFacet", function (event) {

        event.preventDefault();

        //Stop event from triggering twice.
        event.stopImmediatePropagation();

        var element = $(event.target);
        var link = stringToUrl(element.closest(".subCatSelectedFacet").prop("href"));

        $("#plp-results-section").addClass("ajax-overlay");

        $.ajax({
            type: 'GET',
            url: getSelectedFilterUrl(element, link)
        }).done(function (result, textStatus, jqXHR) {

                if ($(result).find("#plp-data [name='redirect']").val()) {

                    submitForm(result);

                } else {

                    pushParamsToHistoryState(this.url);

                    appendResultToHTML(result);

                    comparatorComposite();

                    $("#plp-results-section").removeClass("ajax-overlay");
                }

        }).fail(function () {

                $("#plp-results-section").removeClass("ajax-overlay");

        });
    });

    window.onpopstate = function(event) {

        if ($("#plp-results-section").length) {
            $("#plp-results-section").addClass("ajax-overlay");

            $.ajax({
                type: 'GET',
                url: [location.protocol, '//', location.host, '/', location.pathname, '/async', location.search].join('')
            }).done(function (result, textStatus, jqXHR) {

                    if ($(result).find("#plp-data [name='redirect']").val()) {

                        submitForm(result);

                    } else {

                        appendResultToHTML(result);

                        comparatorComposite();

                        $("#plp-results-section").removeClass("ajax-overlay");
                    }

            }).fail(function () {

                    $("#plp-results-section").removeClass("ajax-overlay");

            });
        }

    }

    /*/

     */
    $(".currency-list a").click(function (){
        $('#selectedCurr').val($(this).data('id'));
        $('#krups-currency-form').submit()
    });
});

/*
 * [BRA-12354] - CSS - vente de prestation standard de réparation
 */
function smoothScrollingTo(target, topOffset) {
  var $target = $(target);
  if ($(".add-service-popup").length > 0) {
    var $modalBody = $(".service-popup .modal-body");
    $modalBody.animate({
      scrollTop: $target.offset().top - $modalBody.offset().top + $modalBody.scrollTop()
    }, 500);
  } else {
    if ($target.offset()) {
      $('html,body').animate({scrollTop: ($target.offset().top) - (topOffset || 80)}, 500);
    }
  }
}

function emptyCoordinatesIfNoLocationQuery(url){
    if(!(new URL(url).searchParams.get("q"))) {
        $("#nearMeStorefinderForm #latitude").val('');
        $("#nearMeStorefinderForm #longitude").val('');
    }
}

function appendStoreLocatorAjaxResultToHTML(result) {
  $('[id="repair-store-filter"]').html($(result).find("#repair-store-filter").html());
  $("#search-filter_repairs").replaceWith($(result).find("#search-filter_repairs").first());
  if ($(".page-my-repairers").length) {
    $(".scroll-store").html($(result).find(".scroll-store").html());
  }
  $("#StoreLocator").html($(result).find("#StoreLocator").html());
}

function pushStoreLocatorParamsToHistoryState(url) {
    var parser = document.createElement('a');
    parser.href = url;
    history.pushState({}, 'storeLocatorQueryParams', parser.search);
}

function Observable() {
  return $.extend(this, $.Deferred(), {
    next: function (value) {
      if (this.skip || this.skipAll) {
        this.skip = (value === 'skip')
        this.skipAll = this.skipAll && (value !== 'activate')
        return this
      }
      if (value === 'skip' || value === 'skipAll') {
        this[value === 'skip' || value === 'skipAll' ? value : 'isActive'] = true
        return this
      }
      return this.notify(value)
    },
    subscribe: function (callback) {
      return this.progress(function (value) {
        callback.call(this, value)
      })
    }
  })
}

function submitStoreLocatorFormWithAjax(form, method) {

    $("#StoreLocator").addClass("ajax-overlay");
    var addServiceUrl="/consumer-services/warranty-and-repairs/repairers-popup";
    var addServicePopup=$("input[name='isAddServicePopup']").val();
    var isAddServicePopup=typeof addServicePopup !== 'undefined'?addServicePopup:false;
    var submitUrl=isAddServicePopup?addServiceUrl:[location.protocol, '//', location.host, location.pathname].join('');

    $.ajax({
        type: method,
        url: submitUrl,
        data: form.serialize()
    }).done(function (result, textStatus, jqXHR) {

          var $StoreLocator = $("#StoreLocator").removeClass("ajax-overlay");

          pushStoreLocatorParamsToHistoryState(isAddServicePopup ? this.url.substring(0, this.url.indexOf('?')) : this.url);

          appendStoreLocatorAjaxResultToHTML(result);

          initScrollingStoreList();
          if (isAddServicePopup) {
            $("#accessory-pointOfServiceName").val("");
          }
      setTimeout(function () {
        if($('#nearMeStorefinderForm').parents('#ModalMessage').length) {
          GSEB.functions.scrollinModal('#ModalMessage .modal-body', isMobile ? '#map-canvas' : '#nearMeStorefinderForm');
        }else{
          GSEB.functions.scrollTo(isMobile ? '#map-canvas' : '#nearMeStorefinderForm', $("header").height() + 10);
        }
      },500);
    }).fail(function (error) {

            $("#StoreLocator").removeClass("ajax-overlay");

            console.log(error);

    });
}

function getStoreLocatorFragment(link) {

    $.ajax({
      type: 'GET',
      url: link
    }).done(function (result, textStatus, jqXHR) {

        pushStoreLocatorParamsToHistoryState(this.url);

        appendStoreLocatorAjaxResultToHTML(result);

        initScrollingStoreList();

        if (isMobile) {
          $observables.storeLocatorObservables.next('storeLocatorRendering')
        }

    }).fail(function (error) {
        console.log(error);
    });
}

$(document).on('click', 'a.pos-feature-link[href^=\\#]', function(event){
    event.preventDefault();
    smoothScrollingTo(this.hash.replace("#","#pos-"));
    var pos_details_block_id = this.hash.replace("#","");
    $("[id^=ShopDetail-]").removeClass("pos-info-block-glow");
    $("[id^=ShopDetail-"+pos_details_block_id+"]").addClass("pos-info-block-glow activate").delay(1000).queue(function(){
        $(this).removeClass("activate").dequeue();
        $("[id^=ShopDetail-]").removeClass("pos-info-block-glow");
    });
});

window.addEventListener('popstate', function (event) {

    if($("#StoreLocator").length && !window.location.hash) {

        var url = [location.protocol, '//', location.host, location.pathname, location.search].join('');

        $("#StoreLocator").addClass("ajax-overlay");

        $.ajax({
            type: 'GET',
            url: url
        }).done(function (result, textStatus, jqXHR) {

                $("#StoreLocator").removeClass("ajax-overlay");

                emptyCoordinatesIfNoLocationQuery(url);

                appendStoreLocatorAjaxResultToHTML(result);

                initScrollingStoreList();

        }).fail(function (error) {

                $("#StoreLocator").removeClass("ajax-overlay");

                console.log(error);

        });

    }

});

/**
 * JS RCU
 */

// Login iFrame loader
(function($) {
    $.fn.bmdIframe = function( options ) {
        var settings = $.extend({
            classBtn: '.bmd-modalButton'
        }, options );

      $(document)
        .on("click", settings.classBtn, function(e){
          // Redirect to full page in case of IE11 or Mobile
          if (GetIEVersion() > 0 && GetIEVersion() <= 11 || isMobile) {
            var linkRedirect = $(this).attr('data-bmdSrc');
            window.location.href = linkRedirect;

          }
          var allowFullscreen = $('.bmd-modalButton').attr('data-bmdVideoFullscreen') || false;

          var attrs = {
            'src': $('.bmd-modalButton').attr('data-bmdSrc')
          };

          if ( allowFullscreen ) attrs.allowfullscreen = "";

          $('.bmd-modalContent [name="login-iframe-item"]').attr(attrs);
          $('.bmd-modalContent [name="login-iframe-item"]').iFrameResize({autoResize : true});


          if(!$(this)[0].hasAttribute("data-toggle") && $(this)[0].hasAttribute("data-bmdsrc")) {
            jQuery("#rcuLoginModal").modal();
          }
        });

        this.on('hidden.bs.modal', function(){
            $(this).find('iframe').html("").attr("src", "");
        });

        return this;
    };

})(jQuery);


jQuery(document).ready(function(){
    jQuery("#rcuLoginModal").bmdIframe();
    $('.bmd-modalContent [name="login-iframe-item"]').css('min-height','500px');
    $('[name="iframe-item"]').iFrameResize({autoResize : true, heightCalculationMethod : 'lowestElement'});
    $('[name="iframe-item"]').css('margin-bottom','50px');

    /*Remove modal target to disable login popup in IE*/
    if (GetIEVersion() > 0 && GetIEVersion() <= 11 || isMobile) {
        $("[data-target=\\#rcuLoginModal]").prop("data-target", null);
    }
    $(".showPopinForDeliveryPage #currencyModal").show();
    $(".showPopinForDeliveryPage #currencyModal").modal();

    /* BRA-21111 - 547771 [SDM - RCU] Problème de time out web */
    var isAutoLoadRCUPopup = $('.bmd-modalButton-auto');
    if(isAutoLoadRCUPopup){
        $('.bmd-modalButton-auto').trigger('click');
    }

});


//Handle Intelligent Tracking Prevention issue for Safari
(function($) {
	if(isRcuActivated){
		var ua = navigator.userAgent.toLowerCase();
		if (ua.indexOf('safari') != -1 ) {
		  if (ua.indexOf('chrome') > -1) {
		    console.log("Do nothing");
		  } else {
			  console.log("Handle the ITP");
			  if ($.cookie("rcuFirstVisit") != "true") {
				  $.cookie("rcuFirstVisit", "true");
				  window.location.replace(sfRedirectTLPUrl);
			  }
		  	}
		}
	}
})(jQuery);

//IP-536 : Logout after anonymisation
(function ($) {
    // Listen to messages sent from the content iframe
    var receiveMessage = function receiveMessage(e) {
        var currentUrl = window.location.href,
            url_parts = currentUrl.split("/"),
            baseUrl = url_parts[0] + "//" + url_parts[2];

        // Handle the message
        switch (e.data) {
            case 'salesforce_accountDeleted':
            {
                //Screen goes back to the deletion confirmation message.
                var $iFrameResizer0 = $('#iFrameResizer0');

                if ($iFrameResizer0.length){
                  $("html, body").animate({
                    scrollTop: $($iFrameResizer0).offset().top - 150
                  }, 500);
                }
                var delay = 5000;
                if (typeof rcuAccountDeletionDelay !== 'undefined') {
                    delay = rcuAccountDeletionDelay;
                }
                window.setTimeout(function () {
                    window.location.replace(baseUrl + "/logout");
                }, delay);

                break;
            }
        }
    };
    window.addEventListener("message", receiveMessage, false)
})(jQuery);

//IP-842 scroll handling
(function($) {
    var receiveMessage = function receiveMessage(e){
        // Handle the message
        switch (e.data) {
            case 'salesforce_actionbutton': case 'salesforce_newpageload': {
            if($('#rcuLoginModal').hasClass('in')) {
                $('#rcuLoginModal').animate({scrollTop: 0}, 250);
            } else {
                $("html, body").animate({scrollTop: 0}, 250);
            }
            break;
        }
        }
    };
    window.addEventListener("message", receiveMessage, false)
})(jQuery);


//IP-799 : Logout after updating password
(function($) {

    // Listen to messages sent from the content iframe
    var receiveMessage = function receiveMessage(e){
        var currentUrl = window.location.href,
            url_parts = currentUrl.split("/"),
            baseUrl = url_parts[0] + "//" + url_parts[2];

        if (currentUrl.indexOf("my-account") >= 0){
	        // Handle the message
	        switch (e.data) {
	            case 'salesforce_login': {
	            	console.log("Logout the current user");
	            	window.location.replace( baseUrl + "/logout");
	            	 break;
	            }
	        }
        }
    };

    window.addEventListener("message", receiveMessage, false);

})(jQuery);

//Get IE Version
function GetIEVersion() {
	  var sAgent = window.navigator.userAgent;
	  var Idx = sAgent.indexOf("MSIE");

	  // If IE, return version number.
	  if (Idx > 0)
	    return parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)));

	  // If IE 11 then look for Updated user agent string.
	  else if (!!navigator.userAgent.match(/Trident\/7\./))
	    return 11;

	  else
		  return 0; //It is not IE
}

$(".extern-cookies-popup").click(function(e) {
    e.preventDefault();
    tC.privacyCenter.showPrivacyCenter();
});

/**
* JS RCU
*/

$('#deliveryPage-currencySelect').on('change',function(){
	$(".btn-action").prop("disabled",false);
});
$(".btn-action.deliveryPage-currency").click(function () {
	var isocode = $('#deliveryPage-currencySelect option:selected').attr('data-id');
	var method = "GET";
	$.ajax({
		url: ACC.config.contextPath + '/exclusion/currency/' + isocode, async: false
	}).done(function (data) {
		if (data.isExcluded == true) {
			$('#selectedCurrDeliveryPage').val(isocode);
			$('#isExludedCurrDeliveryPage').val(true);
		}
		else {
			$('#selectedCurrDeliveryPage').val(isocode);
			$('#isExludedCurrDeliveryPage').val(false);
			$('#currency-form-deliveryPage').submit();
		}
	});
});

$(document).on("click",".add_service_form .add-to-cart", function(e) {

	e.preventDefault(); // prevents the form from being submitted
        $.ajax(
            {
                url:"/cart/add/service/ajax",
                data:$(this).closest("form").serialize(),
                async: false
            }).done(function (data) {
                	var selectModal = "#ModalMessage";
                	if (data.cartError && !data.cartError.msg.length == 0) {
                		modalId = "ModalCartError";
                        $('body')
                            .append(
                            $('<div />')
                                .html(data.cartError.msgModalHtml)
                                .text());
                        selectModal = '#' + modalId;
                        $(selectModal).on('hidden.bs.modal', function () {
                            $(selectModal).remove();
                        });
                    } else {
                    	$(selectModal).html(data);
                        var isForfaitShippingIncluded = $(data).find("[data-forfaitShippingIncluded]").length > 0;
                        if(!isForfaitShippingIncluded) {
                          $observables.storeLocatorObservables.next('skip');
                          ACC.addressgeocode.geocodeAddress();
                        }
                    	$(selectModal).addClass('service-popup');
                        var closeButton = '<button aria-hidden="true" ' +
                                                    'data-dismiss="modal" ' +
                                                    'class="close close--orange" ' +
                                                    'type="button">x</button>';
                        $("#ModalMessage").find('#relayPointsContainer').prepend(closeButton);
                        /*BRA-19430 */
                        $("#ModalMessage").find('#repair-store-filter').on('hidden.bs.collapse', function (e) {
                            if (!e)
                                e = window.event;
                            if (e.stopPropagation) {
                                e.stopPropagation();
                            }
                            else {
                                e.cancelBubble = true;
                            }
                        });
                        $("#ModalMessage").find('.d-none-sm #repair-store-filter').on('hidden.bs.collapse', function (e) {
                            if (!e)
                                e = window.event;
                            if (e.stopPropagation) {
                                e.stopPropagation();
                            }
                            else {
                                e.cancelBubble = true;
                            }
                        });
                    	$("#ModalMessage").on('hidden.bs.modal', function () {
                            $("#ModalMessage .modal-body").html("");
                        });

                    }
                    $(selectModal).show();
                    $(selectModal).modal();
        }).fail(function (error) {
                    console.error("Error trying to add service product: " + error);
                    var modal = $("#ModalMessage");
                    var modalBody = modal.find(".modal-body");
                    var sb = new StringBuilder();
                    sb.append("<p style='margin-bottom: 20px;'>" + GSEB.properties.defaultCartErrorMessage + "</p>");
                    sb.append("<button class='btn btn-action' data-dismiss='modal' style='margin:0 auto; display: block; width: auto; text-align: center'>"+ closePopup +"</button>");
                    modalBody.html(sb.toString());
                    modal.show();
                    modal.modal();
            });

});
 function chooseAspForReparation(currentAsp,aspName){
	 $("input[id='accessory-pointOfServiceName']").val(aspName);
	 $(".asp-choosed").removeClass("asp-choosed");
	 $("#ShopDetail-"+aspName).find(".inner").addClass("asp-choosed");
	 $("#add-service-messageError").hide();
 }


function closeModalMessage(idModalMessage) {
    $('#' + idModalMessage).modal('hide');
    $(".add-service-popup").remove();
}


//RCU Newsletter
$('#register-rules[type="checkbox"][name="conditionRegister"]').prop("checked", false).change();
$('#register-rules, .newsletter-label').on('change', function (e) {
    $('#register-rules').toggleClass('checked');
});

$('.infobulle-gauche').on('click', function (e) {
   $('.infobulle-gauche').toggleClass('isOpen');
});

$(document).ready(function(){
	$("body").mouseup(function(e)
	{
		var container = $('.infobulle-gauche');
		if (!container.is(e.target) && container.has(e.target).length === 0) {
	        container.removeClass('isOpen');
	    }
	});
});
$(document).ready(function(){
    window.$observables = window.$observables || {};
    $observables.prcListObservable = $observables.prcListObservable || new Observable();
    if(isMobile) {
        if($observables){
            $observables.mainObservable.subscribe(function(event) {
                if(event.type === 'prc-scroll-to-maps'){

                    $('#relayPointsContainer').animate({
                        scrollTop: $("#map-canvas").offset().top + 100
                    });
                }

            });
            $observables.prcListObservable.subscribe(function (event) {
                if (event.type === 'prc-list-scroll-to-item') {
                    $container = $('#relayPointsContainer');
                    $scrollToElement = $('#pointAcheminementDetail-'+event.identifiant);
                    $container.animate({
                        scrollTop: $scrollToElement.offset().top - $('.relaitList').offset().top + 700
                    });
                }
            });
        }
    }


    /* BRA-22470 - demande N°3 */
    $('body').on('click','.return-buyonline', function(){
        $('.buy-in-store-popin').find('.close').trigger('click');
    })
    $(document).on("click",".claim-container:not(.main-claim a)",function(e) {
        if(!$(e.target).is('a')){
            document.location.href =$(this).data('product-url');
        }
    });
    $('.claim-container').on("click",".main-claim a",function(e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    });
});

/**
 *  Live-chat
 */

document.addEventListener("DOMContentLoaded", function () {

  if (showChat == "true") {
    if (!GSEB.platform.isMobile()) {
      setTimeout(function () {
        $('.live-chat-block').addClass("live-chat-block-semi-active").removeClass("live-chat-block-inactive");
        setTimeout(function () {
          $('.live-chat-block').addClass("live-chat-block-inactive").removeClass("live-chat-block-semi-active");
        }, liveChatDuration);
      }, liveChatDelay);
    }

    $(".live-chat-block").on("click",".live-chat-picto",function(){
      $('.live-chat-block').addClass("live-chat-block-active").removeClass("live-chat-block-inactive")
        .removeClass("live-chat-block-semi-active");
      $('.live-chat-block').attr("data-analytics-chatClick-chatAction","Open");
      $('.live-chat-block .live-chat-picto').hide(750);
      $('.live-chat-block .live-chat-close').show(750);
    });

    $(".live-chat-block").on("click",".helpButton",function(){
      $('.live-chat-block').attr("data-analytics-chatClick-chatAction", "Ask a question");
    });

    $('.live-chat-block .live-chat-close').click(function (e) {
      $('.live-chat-block').removeClass("live-chat-block-active").addClass("live-chat-block-inactive");
      $('.live-chat-block').attr("data-analytics-chatClick-chatAction","Close");
      $('.live-chat-block .live-chat-picto').show(750);
      $('.live-chat-block .live-chat-close').hide(750);
    });
  }
  if (isMobile == true) {
    if ($(".accessory-banner-container.categoryDiscoverBanner").length > 0) {
      $(".accessory-banner-container.categoryDiscoverBanner").insertBefore(".master-section > .container");
    }
  }
});

if (GetIEVersion() > 0 && GetIEVersion() <= 11) {
  $(".product-viewer-content.image-content .visuel.recipe-media").addClass("recipe-visuel-ie");
}

//scroll poppin to top
var element = document.querySelector('#ModalMessage');
var observer = new MutationObserver(function() {
  document.querySelector("#ModalMessage .modal-body").scrollTo(0,0)
});
observer.observe(element, {
  attributes: true, childList: false
});
